import React, { Component } from "react";
import {
  mode,
  profile,
  alert,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  params,
  required,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  copyText,
  writeClipboard,
} from "../../components/CustomComponent.js";
import html2canvas from "html2canvas";
import { loadPrimerloSdk } from "../../components/primerloWidget.js";
import { NumericFormat } from "react-number-format";

import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";

import LOGO from "../../assets/images/logo-landscape.png";
import GatewayLogo from "../../components/GatewayLogo.js";
import RANK1 from "../../assets/images/rank/rank1.png";
import RANK2 from "../../assets/images/rank/rank2.png";
import RANK3 from "../../assets/images/rank/rank3.png";
import RANK4 from "../../assets/images/rank/rank4.png";
import RANK5 from "../../assets/images/rank/rank5.png";
import RANK6 from "../../assets/images/rank/rank6.png";

const RANK_IMAGES = { 1: RANK1, 2: RANK2, 3: RANK3, 4: RANK4, 5: RANK5, 6: RANK6 };

// การ์ด QR ถูกประกอบเป็นสตริง HTML แล้วส่งเข้า Swal ค่าที่ผู้ใช้พิมพ์จึงต้อง escape ก่อน
// ไม่งั้น ref no ที่มี < > & ทำ markup พังหรือแทรก tag เข้ามาได้
const escapeHtml = (v) =>
  String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

// Gateways whose credentials live in the per-company `credentials` object
// (instead of the legacy merchant_id / merchant_secret_key / apikey fields).
const GATEWAY_CREDENTIAL_FIELDS = {
  chillpay: [
    { key: "merchant_code", label: "Merchant Code" },
    { key: "api_key", label: "API Key" },
    { key: "md5_secret_key", label: "MD5 Secret Key" },
  ],
  xtc: [
    { key: "client_id", label: "Client ID" },
    { key: "merchant_id", label: "Merchant ID" },
    { key: "secret_key", label: "Secret Key" },
    { key: "api_key", label: "API Key" },
  ],
  // Primerlo (Thai QR ขาซื้อ): key_id + secret เซ็น DLR1, webhook_secret ตรวจ webhook,
  // destination_address = address USDT (BEP20) บน BSC ที่ให้ Primerlo ส่งเหรียญเข้า
  primerlo: [
    { key: "key_id", label: "Key ID (dlp_…)" },
    { key: "secret", label: "Secret" },
    { key: "webhook_secret", label: "Webhook Secret (whsec_…)" },
    { key: "destination_address", label: "Destination Address (BSC)" },
  ],
};

// null / "" -> null (unlimited), otherwise a number
const numberOrNull = (v) => (v === "" || v === null || v === undefined || Number.isNaN(Number(v)) ? null : Number(v));
const limitToInput = (v) => (v === null || v === undefined ? "" : String(v));

export default class Brokers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_update_wallet: false,
      active_tab: "info",
      modal_send_certificate: false,
      modal_payment: false,
      // Create Payment บน gateway primerlo: ลูกค้ายังไม่ผ่าน KYC กับ Primerlo -> Backend คืน widget_url ให้แสดง widget ยืนยันตัวตนก่อน
      primerlo_kyc: null,

      filter_search: params("search") || "",
      filter_currency: "THB",
      filter_gateway: "",
      // ฟิลเตอร์ของหน้า list — คนละตัวกับ filter_gateway ที่โมดัลแก้ไขใช้เลือกแท็บค่าธรรมเนียม
      filter_gateway_name: "",

      loaded: false,
      data: [],
      count: 10,
      data_gateway: [],
      data_gateway_company: [],
      data_bank: [],
      data_agent: [],
      data_customer: [],

      customer_id: "",
      payment_type: "",
      amount: "",
      ref_no: "",

      id: "",
      uid: "",
      agent_id: "",
      name_th: "",
      name_en: "",
      email: "",
      phone: "",
      deposit_fee_type: "",
      deposit_fee_value: 0,
      withdrawal_fee_type: "",
      withdrawal_fee_value: 0,
      is_vat: false,
      bank_code: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      bank_account_number: "",
      company_name: "",
      company_address: "",
      company_website: "",
      tax_number: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      room_notify_id: "",
      room_notify_slack_id: "",
      is_notify_balance_payout: false,
      remark: "",
      callback_url: "",
      return_url: "",
      return_url_withdrawal: "",
      callback_url_withdrawal: "",
      gateway_deposits: "",
      gateway_withdrawals: "",
      is_active: true,
      password: "",
      ip_address: [],
      ip_address_input: "",
      ip_address_error: "",
      is_mismatch_first_time: false,
      merchant_id: "",
      merchant_secret_key: "",
      apikey: "",
      authen_key: "",
      link: "",

      is_deposit_queue: false,
      is_withdrawal_queue: false,

      expire_at: "",
      password_certificate: "",
      gateway_active: [],
      gateway_fee_rate: [],
      show_gateway_secret: false,
      reveal_fields: {}, // ปุ่ม Show/Hide รายช่องของ credential key = `${company_key}:${field}`
      // การ์ด company ที่ถูกย่อ key = uid ของแถว หรือ _key ของแถวที่ยังไม่บันทึก
      collapsed_companies: {},
      // ช่องที่ถูกแก้ในโมดัล key = `${company_key}:${group}` ใช้แสดงปุ่ม Apply to all (ดู APPLY_GROUPS)
      edited_fields: {},

      wallets: [],

      currency: "",
    };
  }

  componentWillUnmount() {
    this.DestroyPrimerloWidget();
  }
  async componentDidMount() {
    loading(false);
    // master data (gateway / bank / agent) ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
    // ของเดิมดึงใหม่ทุกครั้งที่ค้นหา เปลี่ยนหน้า หรือสลับสกุลเงิน ทั้งที่ banks ขอมาทีละแสนแถว
    await Promise.all([this.GetMaster(), this.Get(1)]);
  }
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_gateway, data_bank, data_agent;
    let [result_gateway, result_bank, result_agent, result_company] = await Promise.all([
      GET("gateway-rules/list", { page_size: 100000, page: 0, data_search: "" }),
      GET("v1/admin/banks", { page_size: 100000, page: 0, data_search: "" }),
      GET("v1/admin/agents", { page_size: 100000, page: 0, data_search: "" }),
      // company กลาง (Center Config › Config Company) ให้เลือกในแต่ละแถว gateway
      GET("v1/admin/gateway-companies", null),
    ]);
    const data_gateway_company = result_company?.status ? result_company.data || [] : [];
    if (result_gateway?.status) {
      data_gateway = result_gateway.data.map((e) => ({
        value: e.gateway_code,
        label: e.gateway_name,
        country: e.country,
      }));
    }
    if (result_bank?.status) {
      const popularBankCodes = [
        "SCB",
        "KBANK",
        "KTB",
        "BBL",
        "BAY",
        "TTB",
        "CIMB",
      ];
      data_bank = result_bank.data
        .sort((a, b) => {
          const indexA = popularBankCodes.indexOf(a.code);
          const indexB = popularBankCodes.indexOf(b.code);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
          } else if (indexA !== -1) {
            return -1; // a อยู่ใน popular → ให้มาก่อน
          } else if (indexB !== -1) {
            return 1; // b อยู่ใน popular → ให้มาก่อน
          } else {
            return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
          }
        })
        .map((e) => ({
          value: e.code,
          label: e.name_en,
          front: (
            <img
              alt="bank"
              src={require(
                `../../assets/images/bank/${
                  global.bank.find((b) => b.value === e.code)?.icon ||
                  "bank.png"
                }`,
              )}
              width={18}
              height={18}
              style={{ marginRight: 6 }}
            />
          ),
          bank_gateway_mappings: e.bank_gateway_mappings,
        }));
    }
    if (result_agent?.status) {
      data_agent = result_agent.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
      }));
    }
    this.setState({ data_gateway, data_bank, data_agent, data_gateway_company });
  };
  Get = async (page) => {
    loading(true);
    let data, count;
    let result = await GET("v1/admin/brokers", {
      page_size: 10,
      page: page,
      data_search: this.state.filter_search,
      currency: this.state.filter_currency,
      gateway: this.state.filter_gateway_name,
    });
    if (result?.status) {
      data = result.data;
      count = result.pagination?.count;
    }
    this.setState({
      loaded: true,
      data,
      count,
    });
    loading(false);
  };
  GetCustomer = async (data_search = "") => {
    const { currency, uid } = this.state;
    let data_customer = [];

    let result = await GET("v1/admin/customers", {
      page_size: 50,
      page: 1,
      data_search: data_search,
      currency: currency,
      broker_id: uid,
    });

    if (result?.status) {
      // โลโก้ธนาคารแทนชื่อย่อในตัวเลือก (front ถูกวาดทั้งในช่องที่เลือกและในลิสต์)
      const formatCustomer = (e) => ({
        value: e.uid,
        label: `${e.name_en} (${e.bank_account_number})`,
        front: (
          <img
            alt={e.bank_code || "bank"}
            title={e.bank_code || ""}
            src={require(`../../assets/images/bank/${global.bank.find((b) => b.value === e.bank_code)?.icon || "bank.png"}`)}
            width={18}
            height={18}
            style={{ marginRight: 6, borderRadius: 4, objectFit: "cover" }}
          />
        ),
        bank_code: e.bank_code,
        bank_account_name_th: e.bank_account_name_th,
        bank_account_name_en: e.bank_account_name_en,
        bank_account_number: e.bank_account_number,
        broker: e.broker?.uid || "",
        currency: e.currency || "THB",
      });

      data_customer = result.data.map(formatCustomer);

    }

    this.setState({ data_customer });
  };
  GetByID = async (id) => {
    const { filter_search, filter_currency, data_gateway } = this.state;
    loading(true);
    let result = await GET("v1/admin/brokers", {
      page_size: 100000,
      page: 0,
      data_search: filter_search,
      uid: id,
      currency: filter_currency,
    });
    if (result?.status) {
      let gateway_register = result.data?.gateway_register;
      // One entry per gateway_register row (one row = one company). A gateway with
      // no row yet still gets a single default entry, as before.
      let gateway_fee_rate = (data_gateway || []).flatMap((e) => {
        const rows = (gateway_register || []).filter((g) => g.gateway_name === e.label);
        return (rows.length ? rows : [undefined]).map((item) => ({
          ...item,
          id: item?.id || "",
          uid: item?.uid || undefined,
          gateway_name: e.label,
          company_name: item?.company_name || "",
          business_type: item?.business_type || "",
          gateway_company_uid: item?.gateway_company_uid || null,
          usage_scope: item?.usage_scope || "broker",
          priority: item?.priority ?? 1,
          min_gmv_per_transaction: limitToInput(item?.min_gmv_per_transaction),
          limit_gmv_per_transaction: limitToInput(item?.limit_gmv_per_transaction),
          limit_gmv_per_day: limitToInput(item?.limit_gmv_per_day),
          limit_gmv_per_month: limitToInput(item?.limit_gmv_per_month),
          credentials: { ...(item?.credentials || {}) },
          usage_today: item?.usage_today || null,
          deposit_fee_type: item?.deposit_fee_type || "percentage",
          deposit_fee_value: item?.deposit_fee_value || "",
          payment_min_deposit: item?.payment_min_deposit || 0,
          withdrawal_fee_type: item?.withdrawal_fee_type || "percentage",
          withdrawal_fee_value: item?.withdrawal_fee_value || "",
          payment_min_withdrawal: item?.payment_min_withdrawal || 0,
          is_vat: item?.is_vat || true,
          is_active: item?.is_active || false,
          bank_code: item?.bank_code || "",
          bank_account_name_th: item?.bank_account_name_th || "",
          bank_account_name_en: item?.bank_account_name_en || "",
          bank_account_number: item?.bank_account_number || "",
          merchant_id: item?.merchant_id || "",
          authen_key: item?.authen_key || "",
          merchant_secret_key: item?.merchant_secret_key || "",
          apikey: item?.apikey || "",
          return_url: item?.return_url || "",
          callback_url: item?.callback_url || "",
          return_url_withdrawal: item?.return_url_withdrawal || "",
          callback_url_withdrawal: item?.callback_url_withdrawal || "",
          remark: item?.remark || "",

          wallets: item?.wallets || [],
        }));
      });
      this.setState({
        ...result.data,
        agent_id: result.data?.agent?.uid,
        client_id: result.data?.entity_config?.client_id,
        client_secret: result.data?.entity_config?.client_secret,
        client_ref_id: result.data?.entity_config?.client_ref_id,
        x_apigw_api_id: result.data?.entity_config?.x_apigw_api_id,
        ip_address:
          result.data?.entity_config?.ip_address
            ?.split(",")
            .map((e) => e.trim())
            .filter(Boolean) || [],
        ip_address_input: "",
        ip_address_error: "",
        show_gateway_secret: false,
        reveal_fields: {},
        collapsed_companies: {},
        edited_fields: {},
        is_mismatch_first_time: result.data?.is_mismatch_first_time,
        // keep the raw timestamp; the Detail popup formats it once for display.
        // Formatting here caused a double-format that rendered as "-".
        expire_at: result.data?.entity_config?.expire_at || "",
        password_certificate: result.data?.entity_config?.password || "",
        gateway_fee_rate,
        filter_gateway: gateway_fee_rate[0]?.gateway_name || "",
        link: result.data?.entity_config?.link || "",
      });
    }
    loading(false);
  };
  RecalWallet = async (id) => {
    const { filter_currency } = this.state;
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let result = await POST("v1/admin/wallets/recal", {
        broker_id: id,
        currency: filter_currency,
      });
      if (result?.status === true) {
          alert("#", "success");
      } else {
          alert("", "warning", "Warning", result?.message || "An error occurred. Please try again.");
      }
      loading(false);
    }
  };
  GetGatewayInfoByID = async (id) => {
    const { data_gateway } = this.state;
    loading(true);
    let result = await GET("v1/admin/brokers", {
      uid: atob(id.replaceAll(global.breplace, "")),
    });
    if (result?.status) {
      let gateway_fee_rate = data_gateway?.map((e) => {
        let item = result.data?.gateway_register?.find(
          (g) => g.gateway_name === e.label,
        );
        return {
          gateway_name: e.label,
          deposit_fee_type: "percentage",
          deposit_fee_value: item?.deposit_fee_value,
          payment_min_deposit: 0,
          withdrawal_fee_type: "percentage",
          withdrawal_fee_value: item?.withdrawal_fee_value,
          payment_min_withdrawal: 0,
          is_vat: true,
          is_active: true,
          bank_code: "",
          bank_account_name_th: "",
          bank_account_name_en: "",
          bank_account_number: "",
          merchant_id: item?.merchant_id || "",
          authen_key: item?.authen_key || "",
          merchant_secret_key: item?.merchant_secret_key || "",
          apikey: item?.apikey || "",
          return_url: "",
          callback_url: "",
          return_url_withdrawal: "",
          callback_url_withdrawal: "",
          remark: "",
        };
      });
      this.setState({
        gateway_fee_rate,
        gateway_active: global.currency.map((e) => ({
          currency: e.currency_code,
          is_active: true,
          gateway_deposits: e.currency_code === "THB" ? "payso" : "uniqpay",
          gateway_withdrawals: e.currency_code === "THB" ? "spark" : "uniqpay",
          payment_min_deposit: 0,
          payment_min_withdrawal: 0,
        })),
        filter_gateway: gateway_fee_rate[0]?.gateway_name || "",
      });
    }
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      uid,
      agent_id,
      name_th,
      name_en,
      email,
      phone,
      deposit_fee_type,
      deposit_fee_value,
      withdrawal_fee_type,
      withdrawal_fee_value,
      is_vat,
      bank_code,
      bank_account_name_th,
      bank_account_name_en,
      bank_account_number,
      company_name,
      company_address,
      company_website,
      tax_number,
      contact_name,
      contact_email,
      contact_phone,
      room_notify_id,
      room_notify_slack_id,
      is_notify_balance_payout,
      remark,
      callback_url,
      return_url,
      return_url_withdrawal,
      callback_url_withdrawal,
      is_active,
      gateway_deposits,
      gateway_withdrawals,
      password,
      modal_create,
      modal_update,
      ip_address,
      is_mismatch_first_time,
      merchant_id,
      merchant_secret_key,
      apikey,
      authen_key,
      gateway_active,
      gateway_fee_rate,
      wallets,

      is_deposit_queue,
      is_withdrawal_queue,

      deposit_commission_type,
      deposit_commission_value,
      withdrawal_commission_type,
      withdrawal_commission_value,
    } = this.state;
    if (!agent_id.trim()) {
      alert("", "warning", "Warning", "Please select Agent");
      return;
    } else if (!name_th.trim()) {
      alert("", "warning", "Warning", "Please input Name TH");
      return;
    } else if (!name_en?.trim()) {
      alert("", "warning", "Warning", "Please input Name EN");
      return;
    } else if (!email?.trim()) {
      alert("", "warning", "Warning", "Please input Email");
      return;
    } else if (!phone?.trim()) {
      alert("", "warning", "Warning", "Please input Phone");
      return;
    } else if (!company_name?.trim()) {
      alert("", "warning", "Warning", "Please input Company Name");
      return;
    } else if (!company_address?.trim()) {
      alert("", "warning", "Warning", "Please input Company Address");
      return;
    } else if (!company_website?.trim()) {
      alert("", "warning", "Warning", "Please input Company Website");
      return;
    } else if (!contact_name?.trim()) {
      alert("", "warning", "Warning", "Please input Contact Name");
      return;
    } else if (!contact_email?.trim()) {
      alert("", "warning", "Warning", "Please input Contact Email");
      return;
    } else if (!contact_phone?.trim()) {
      alert("", "warning", "Warning", "Please input Contact Phone");
      return;
    }
    if (modal_create) {
      if (!password) {
        alert("", "warning", "Warning", "Please input Password");
        return;
      }
    }

    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let body = {
        agent_id,
        name_th,
        name_en,
        email,
        phone,
        // deposit_fee_type,
        // deposit_fee_value: Number(deposit_fee_value),
        // withdrawal_fee_type,
        // withdrawal_fee_value: Number(withdrawal_fee_value),
        // is_vat,
        bank_code,
        bank_account_name_th,
        bank_account_name_en,
        bank_account_number,
        company_name,
        company_address,
        company_website,
        tax_number,
        contact_name,
        contact_email,
        contact_phone,
        room_notify_id,
        room_notify_slack_id,
        is_notify_balance_payout,
        remark,
        callback_url,
        return_url,
        return_url_withdrawal,
        callback_url_withdrawal,
        gateway_deposits,
        gateway_withdrawals,
        is_active,
        ip_address: ip_address
          ? (typeof ip_address === "string" ? ip_address.trim(",") : ip_address)
              .filter((e) => e)
              .map((e) => e.trim())
              .toString() || ""
          : "",
        is_mismatch_first_time,
        merchant_id,
        merchant_secret_key,
        apikey,
        authen_key,
        password,
        gateway_active: gateway_active.map((e) => ({
          ...e,
          is_active: e.gateway_deposits || e.gateway_withdrawals ? true : false,
          payment_min_deposit: Number(e.payment_min_deposit) || 0,
          payment_min_withdrawal: Number(e.payment_min_withdrawal) || 0,
          // total_deposits: Number(e.total_deposits) || 0,
          // total_fee: Number(e.total_fee) || 0,
          // total_vat: Number(e.total_vat) || 0,
          // total_withdrawals: Number(e.total_withdrawals) || 0,
        })),
        gateway_fee_rate: gateway_fee_rate.map((e) => {
          // eslint-disable-next-line no-unused-vars
          const { usage_today, usage_scope, credentials, uid: row_uid, _key, ...rest } = e;
          const row = {
            ...rest,
            deposit_fee_value: Number(e.deposit_fee_value),
            withdrawal_fee_value: Number(e.withdrawal_fee_value),
            company_name: e.company_name || "",
            business_type: e.business_type || "",
            // null = ไม่ผูก company กลาง (ส่ง null ชัด ๆ เพราะ POST/PUT ตัด "" ทิ้ง)
            gateway_company_uid: e.gateway_company_uid || null,
            priority: parseInt(e.priority, 10) || 1,
            min_gmv_per_transaction: numberOrNull(e.min_gmv_per_transaction),
            limit_gmv_per_transaction: numberOrNull(e.limit_gmv_per_transaction),
            limit_gmv_per_day: numberOrNull(e.limit_gmv_per_day),
            limit_gmv_per_month: numberOrNull(e.limit_gmv_per_month),
          };
          if (row_uid) row.uid = row_uid;
          const cred_fields = GATEWAY_CREDENTIAL_FIELDS[e.gateway_name];
          if (cred_fields) {
            const cred = {};
            cred_fields.forEach((f) => {
              cred[f.key] = String(credentials?.[f.key] ?? "").trim();
            });
            row.credentials = Object.values(cred).some(Boolean) ? cred : null;
          }
          return row;
        }),

        is_deposit_queue,
        is_withdrawal_queue,

        deposit_commission_type: deposit_commission_type,
        deposit_commission_value: Number(deposit_commission_value),
        withdrawal_commission_type: withdrawal_commission_type,
        withdrawal_commission_value: Number(withdrawal_commission_value),
      };
      if(!modal_create){
        body.wallets = wallets.map((e) => ({
          ...e,
          min_balance: Number(e.min_balance),
        }));
      }

      let result = !uid
        ? await POST("v1/admin/brokers", body)
        : await PUT("v1/admin/brokers/" + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        "Do you really want to delete this item?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let result = await DELETE("v1/admin/brokers/" + id, null);
      if (result?.status === true) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  // Accepts IPv4, optionally with a CIDR suffix (192.168.1.0/24).
  IsValidIpAddress = (value) => {
    const match = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})(\/(\d|[12]\d|3[0-2]))?$/.exec(
      value,
    );
    if (!match) return false;
    return [1, 2, 3, 4].every((i) => Number(match[i]) <= 255);
  };
  // Adds one or many addresses at once. The text may be typed or pasted and
  // separated by comma, semicolon, space or newline. Duplicates are ignored and
  // the state stays an array of plain strings, which is what Submit joins with
  // a comma before sending to the API.
  AddIpAddress = (text) => {
    const items = String(text || "")
      .split(/[\s,;]+/)
      .map((e) => e.trim())
      .filter(Boolean);
    if (!items.length) return;
    const invalid = items.filter((e) => !this.IsValidIpAddress(e));
    if (invalid.length) {
      this.setState({
        ip_address_error: "Invalid IP Address: " + invalid.join(", "),
      });
      return;
    }
    const next = [...this.state.ip_address];
    const duplicate = items.filter((e) => next.includes(e));
    items.forEach((e) => {
      if (!next.includes(e)) next.push(e);
    });
    this.setState({
      ip_address: next,
      ip_address_input: "",
      ip_address_error: duplicate.length
        ? "Already added: " + duplicate.join(", ")
        : "",
    });
  };
  RemoveIpAddress = async (index) => {
    // Matched by value, not by index: the confirm is awaited and the list can
    // change while it is open. Values are unique, duplicates are blocked on add.
    const value = this.state.ip_address[index];
    if (!value) return;
    if (
      await alert(
        "",
        "warning",
        "Delete IP Address",
        `Do you really want to remove ${value} from the whitelist?`,
        "Confirm",
        "Cancel",
      )
    ) {
      this.setState({
        ip_address: this.state.ip_address.filter((e) => e !== value),
        ip_address_error: "",
      });
    }
  };
  // ตัวเลือกของฟิลเตอร์ gateway บนหน้า list ตัดตามสกุลเงินที่เลือกอยู่
  // แยกจาก GatewayOptions ของโมดัลเพราะตัวเลือกว่างคนละความหมาย
  // (ที่นี่คือ "ไม่กรอง" ส่วนในโมดัลคือ "ยังไม่ได้เลือก")
  GatewayFilterOptions = () => [
    { value: "", label: "All Gateway" },
    ...(this.state.data_gateway
      ?.filter((e) => e.country === this.state.filter_currency || !e.country)
      .map((item) => ({
        value: item.value,
        label: item.label,
        front: <div className="me-2"><GatewayLogo name={item.value} size={22} /></div>,
      })) || []),
  ];
  // Options for the Payment tab gateway dropdowns. `front` is rendered by Select
  // both in the list and next to the selected value.
  GatewayOptions = (currency) => [
    { value: "", label: "--Select Gateway--" },
    ...(this.state.data_gateway
      ?.filter((e) => e.country === currency || !e.country)
      .map((item) => ({
        value: item.value,
        label: item.label,
        front: <div className="me-2"><GatewayLogo name={item.value} size={22} /></div>,
      })) || []),
  ];
  // Writes one field of one gateway row. Every Gateway Config input goes through
  // here so the shape of gateway_fee_rate stays exactly what the API expects.
  SetFormField = (index, field, value) => {
    const gateway_fee_rate = this.state.gateway_fee_rate;
    gateway_fee_rate[index][field] = value;
    this.setState({ gateway_fee_rate });
  };
  // ปุ่ม "Apply to all" ใต้ช่องที่ถูกแก้ ค่าธรรมเนียมใช้กับ gateway ของสกุลเดียวกัน (THB/LAK แยกกัน)
  // ส่วน callback/return url ใช้กับทุก gateway ทุก company · ค่ายังไม่บันทึกจนกด Submit
  APPLY_GROUPS = {
    deposit_fee: { label: "Deposit Fee Rate", fields: ["deposit_fee_value", "deposit_fee_type"], by_currency: true },
    withdrawal_fee: { label: "Withdraw Fee Rate", fields: ["withdrawal_fee_value", "withdrawal_fee_type"], by_currency: true },
    callback_url: { label: "Callback Deposit", fields: ["callback_url"] },
    callback_url_withdrawal: { label: "Callback Withdraw", fields: ["callback_url_withdrawal"] },
    return_url: { label: "Return Deposit", fields: ["return_url"] },
    return_url_withdrawal: { label: "Return Withdraw", fields: ["return_url_withdrawal"] },
  };
  MarkEdited = (index, group) => {
    const key = `${this.CompanyKey(this.state.gateway_fee_rate[index], index)}:${group}`;
    if (this.state.edited_fields[key]) return;
    this.setState({ edited_fields: { ...this.state.edited_fields, [key]: true } });
  };
  SetApplyField = (index, field, value, group) => {
    this.SetFormField(index, field, value);
    this.MarkEdited(index, group);
  };
  // แถวอื่นที่ค่ายังไม่ตรงกับแถวต้นทาง ค่าธรรมเนียมเลือกเฉพาะ gateway ที่ตั้งประเทศตรงกับสกุลนั้น
  // gateway ที่ไม่ได้ตั้งประเทศ (เช่น manual) ใช้ค่าเดียวทั้ง THB/LAK จึงไม่ถูกเปลี่ยนตาม
  ApplyTargets = (index, group, currency) => {
    const { gateway_fee_rate, data_gateway } = this.state;
    const conf = this.APPLY_GROUPS[group];
    const src = gateway_fee_rate[index];
    const names = conf.by_currency
      ? (data_gateway || []).filter((e) => e.country === currency).map((e) => e.label)
      : null;
    const same = (field, a, b) => (field.endsWith("_fee_value") ? Number(a || 0) === Number(b || 0) : (a ?? "") === (b ?? ""));
    return gateway_fee_rate
      .map((e, i) => i)
      .filter((i) => i !== index && (!names || names.includes(gateway_fee_rate[i].gateway_name)))
      .filter((i) => conf.fields.some((f) => !same(f, gateway_fee_rate[i][f], src[f])));
  };
  ApplyToAll = async (index, group, currency) => {
    const conf = this.APPLY_GROUPS[group];
    const targets = this.ApplyTargets(index, group, currency);
    if (!targets.length) return;
    const src = this.state.gateway_fee_rate[index];
    const shown = conf.by_currency
      ? `${src[conf.fields[0]] || 0} ${src[conf.fields[1]] === "percentage" ? "%" : currency}`
      : src[conf.fields[0]] || "(empty)";
    const scope = conf.by_currency ? `${currency} gateway` : "gateway";
    if (
      await alert(
        "",
        "info",
        `Apply to all ${scope}s`,
        `Set ${conf.label} to ${shown} on ${targets.length} other ${scope}${targets.length === 1 ? "" : "s"}? Changes are saved when you press Submit.`,
        "Confirm",
        "Cancel",
      )
    ) {
      const gateway_fee_rate = [...this.state.gateway_fee_rate];
      targets.forEach((i) => {
        gateway_fee_rate[i] = { ...gateway_fee_rate[i] };
        conf.fields.forEach((f) => (gateway_fee_rate[i][f] = src[f]));
      });
      this.setState({ gateway_fee_rate });
    }
  };
  ApplyAllButton = (index, group, currency) => {
    const item = this.state.gateway_fee_rate[index];
    if (!item || !this.state.edited_fields[`${this.CompanyKey(item, index)}:${group}`]) return null;
    if (!this.ApplyTargets(index, group, currency).length) return null;
    return (
      <small className="pu-copy-link pointer d-inline-block mt-1" onClick={() => this.ApplyToAll(index, group, currency)}>
        <span className="icon me-1">{"\uf0c5"}</span>
        {this.APPLY_GROUPS[group].by_currency ? `Apply to all ${currency} gateways` : "Apply to all gateways"}
      </small>
    );
  };
  SetCredential = (index, key, value) => {
    const gateway_fee_rate = this.state.gateway_fee_rate;
    gateway_fee_rate[index].credentials = { ...(gateway_fee_rate[index].credentials || {}), [key]: value };
    this.setState({ gateway_fee_rate });
  };
  // Appends a new company row for the selected gateway. Fee settings are copied
  // from the first row of that gateway; company, limits and credentials start empty.
  AddCompany = () => {
    const { gateway_fee_rate, filter_gateway } = this.state;
    const rows = gateway_fee_rate.filter((e) => e.gateway_name === filter_gateway);
    const base = rows[0];
    if (!base) return;
    const priority = Math.max(0, ...rows.map((e) => parseInt(e.priority, 10) || 0)) + 1;
    const entry = {
      _key: `new-${Date.now()}`,
      gateway_name: filter_gateway,
      company_name: "",
      business_type: "",
      gateway_company_uid: null,
      usage_scope: "broker",
      priority,
      min_gmv_per_transaction: "",
      limit_gmv_per_transaction: "",
      limit_gmv_per_day: "",
      limit_gmv_per_month: "",
      credentials: {},
      usage_today: null,
      deposit_fee_type: base.deposit_fee_type,
      deposit_fee_value: base.deposit_fee_value,
      payment_min_deposit: base.payment_min_deposit,
      withdrawal_fee_type: base.withdrawal_fee_type,
      withdrawal_fee_value: base.withdrawal_fee_value,
      payment_min_withdrawal: base.payment_min_withdrawal,
      is_vat: base.is_vat,
      is_active: base.is_active,
      bank_code: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      bank_account_number: "",
      merchant_id: "",
      authen_key: "",
      merchant_secret_key: "",
      apikey: "",
      return_url: "",
      callback_url: "",
      return_url_withdrawal: "",
      callback_url_withdrawal: "",
      remark: "",
    };
    // keep rows of the same gateway together
    let last = -1;
    gateway_fee_rate.forEach((e, i) => {
      if (e.gateway_name === filter_gateway) last = i;
    });
    const next = [...gateway_fee_rate];
    next.splice(last + 1, 0, entry);
    // ย่อการ์ดเดิมของ gateway นี้ให้เหลือแค่หัว เปิดเฉพาะ company ใหม่ที่ต้องกรอก
    const collapsed_companies = { ...this.state.collapsed_companies };
    rows.forEach((e) => {
      collapsed_companies[this.CompanyKey(e, gateway_fee_rate.indexOf(e))] = true;
    });
    collapsed_companies[entry._key] = false;
    this.setState({ gateway_fee_rate: next, collapsed_companies });
  };
  // เลือก company กลาง: ชื่อ/ประเภท/เพดานวัน-เดือนมาจาก master (แก้ได้ที่ Center Config › Config Company)
  SelectGatewayCompany = (index, uid) => {
    const m = this.state.data_gateway_company.find((c) => c.uid === uid);
    const gateway_fee_rate = [...this.state.gateway_fee_rate];
    gateway_fee_rate[index] = {
      ...gateway_fee_rate[index],
      gateway_company_uid: m ? m.uid : null,
      company_name: m ? m.company_name : gateway_fee_rate[index].company_name,
      business_type: m ? m.business_type : gateway_fee_rate[index].business_type,
      limit_gmv_per_day: m ? limitToInput(m.limit_gmv_per_day) : gateway_fee_rate[index].limit_gmv_per_day,
      limit_gmv_per_month: m ? limitToInput(m.limit_gmv_per_month) : gateway_fee_rate[index].limit_gmv_per_month,
      // ยอดใช้ของ company ใหม่จาก master (รวมทุก broker)
      usage_today: m ? m.usage_today : gateway_fee_rate[index].usage_today,
      usage_scope: m ? "company" : "broker",
    };
    this.setState({ gateway_fee_rate });
  };
  // key คงที่ของการ์ด ใช้จำสถานะย่อ/ขยายและใช้หา row ตอนลบ (index เลื่อนได้เมื่อมีการลบ)
  CompanyKey = (item, index) => item.uid || item._key || `new-${index}`;
  ToggleCompany = (key) => {
    const collapsed_companies = { ...this.state.collapsed_companies };
    collapsed_companies[key] = !collapsed_companies[key];
    this.setState({ collapsed_companies });
  };
  // Only unsaved rows (no uid) can be dropped, and a gateway always keeps one row.
  RemoveCompany = async (index) => {
    const { gateway_fee_rate } = this.state;
    const item = gateway_fee_rate[index];
    if (!item || item.uid) return;
    if (gateway_fee_rate.filter((e) => e.gateway_name === item.gateway_name).length < 2) return;
    const key = this.CompanyKey(item, index);
    const name = item.company_name || `Company #${item.priority || ""}`;
    if (
      await alert(
        "",
        "warning",
        "Remove Company",
        `Do you really want to remove ${name} from ${item.gateway_name}? Unsaved values in this card will be lost.`,
        "Confirm",
        "Cancel",
      )
    ) {
      // หาใหม่ด้วย key เพราะระหว่างรอ confirm ลำดับใน list อาจเปลี่ยนได้
      this.setState({ gateway_fee_rate: this.state.gateway_fee_rate.filter((e, i) => this.CompanyKey(e, i) !== key) });
    }
  };
  // One labelled field used by the modal cards. Called as a plain function,
  // not mounted as a component, so the inputs keep focus while typing.
  // ตัวเลือกคงที่จาก global.js ถ้าค่าที่บันทึกไว้แล้วไม่อยู่ใน list ให้แทรกเข้าไปด้วย เพื่อให้แถวเก่ายังแสดงค่าเดิมได้
  // ไม่ต้องใส่ตัวเลือกว่างเอง เพราะ Select มีแถว "-- Please select --" ให้อยู่แล้ว
  FixedOptions = (list, current) => {
    const options = [...(list || [])];
    if (current && !options.find((e) => e.value === current)) options.push({ value: current, label: current });
    return options;
  };
  ToggleReveal = (key) => {
    const reveal_fields = { ...this.state.reveal_fields };
    reveal_fields[key] = !reveal_fields[key];
    this.setState({ reveal_fields });
  };
  // reveal: { shown, onToggle } แสดงปุ่ม Show/Hide ข้างปุ่ม Copy สำหรับช่องที่เป็น password
  // action: ลิงก์เล็กใต้ช่อง (เช่นปุ่ม Apply to all gateways)
  FormField = ({ label, value, onChange, placeholder, type, maxLength, copy, hint, children, reveal, action }) => (
    <div className="mb-3">
      <div className="d-flex align-items-center justify-content-between mb-1">
        <label className="pr-label mb-0">{label}</label>
        <div className="d-flex align-items-center">
          {reveal ? (
            <small className="pu-copy-link pointer me-3" onClick={reveal.onToggle}>
              <span className="icon me-1">{reveal.shown ? "\uf070" : "\uf06e"}</span>
              {reveal.shown ? "Hide" : "Show"}
            </small>
          ) : null}
          {copy && value ? (
            <small className="pu-copy-link pointer" onClick={() => copyText(value)}>
              <span className="icon me-1">{"\uf0c5"}</span>Copy
            </small>
          ) : null}
        </div>
      </div>
      {children || (
        <input
          type={type || "text"}
          className="form-control pr-input"
          placeholder={placeholder}
          maxLength={maxLength}
          onChange={onChange}
          value={value}
        />
      )}
      {hint ? <div className="pu-hint">{hint}</div> : null}
      {action || null}
    </div>
  );
  RemoveAllIpAddress = async () => {
    const total = this.state.ip_address.length;
    if (!total) return;
    if (
      await alert(
        "",
        "warning",
        "Delete All IP Address",
        `Do you really want to remove all ${total} IP address${total === 1 ? "" : "es"} from the whitelist?`,
        "Confirm",
        "Cancel",
      )
    ) {
      this.setState({ ip_address: [], ip_address_error: "" });
    }
  };
  CreatePayment = async () => {
    loading(true);
    const {
      customer_id,
      payment_type,
      amount,
      ref_no,
      client_id,
      client_secret,
      client_ref_id,
      x_apigw_api_id,
      currency,
    } = this.state;
    const body = {
      customer_id,
      amount,
      ref_no,
      client_id,
      client_secret,
      client_ref_id,
      "x-apigw-api-id": x_apigw_api_id,
      currency,
    };
    let result = await POST(`transactions/${payment_type}/partner`, body);
    if (result?.status) {
      // primerlo ขั้น 1 ไม่ผ่าน: ต้องให้ลูกค้ายืนยันตัวตนกับ Primerlo ใน widget ก่อน แล้วค่อยสร้างใบ (kyc เสร็จจะ submit ซ้ำให้เอง)
      if (result?.data?.mode === "kyc") {
        loading(false);
        const kyc = { widget_url: result.data.widget_url, session_id: result.data.session_id, customer: result.data.customer, message: "" };
        this.setState({ primerlo_kyc: kyc }, () => this.MountPrimerloKyc(kyc.widget_url));
        return;
      }
      if (result?.data?.status?.message === "Success") {
        if (payment_type === "deposits") {
          // ใช้ ref_no ที่ API คืนมาเป็นหลัก ไม่ใช่ค่าที่พิมพ์ในฟอร์ม เพราะถ้ายิงซ้ำด้วย ref เดิม
          // ระบบจะคืนใบเดิมกลับมา ค่าที่ควรโชว์บน QR คือของใบที่ได้จริง
          const qrRefNo = result?.data?.data?.ref_no || ref_no || "-";
          this.setState({ modal_payment: false });
          Swal.fire({
            showCloseButton: true,
            confirmButtonText: "Download",
            customClass: {
              actions: "mt-0",
            },
            html: `
            <div class="p-3" id="qrcode">
            <div class="rounded-3 bg-white overflow-hidden shadow" style="border: 1px solid #eee;">
                    <img
                      alt="logo"
                      src="${LOGO}"
                      class="w-50 mx-auto mt-5 mb-3"
                    />
                    <div class="d-flex justify-content-center">
                      <div class="rounded-3 px-5 mx-auto bg-gold px-3 py-2 text-center text-white fw-bold mb-3">
                        DEPOSIT QR CODE
                      </div>
                    </div>

                    <div class="bg-white p-2 w-75 rounded-3 mx-auto mb-3">
                      <img
                        src="${(result?.data?.data?.base64)?.replaceAll(
                          "_",
                          "+",
                        )}"
                        alt="QR code"
                        class="img-fluid w-100"
                      />
                    </div>
                    <div class="text-center mb-3">
                      <div class="text-secondary" style="font-size: 12px; line-height: 14px;">Ref No.</div>
                      <div class="fw-bold" style="font-size: 16px; word-break: break-all;">${escapeHtml(qrRefNo)}</div>
                    </div>
                    <div class="bg-gold pt-4 pb-3">
                      <h4 class="text-center text-white">
                        amount : ${toFixed(amount)} ${currency}
                      </h4>
                    </div>
                  </div>
                  </div>
            `,
            preConfirm: async () => {
              const qrDiv = document.getElementById("qrcode");
              if (qrDiv) {
                const canvas = await html2canvas(qrDiv);
                const imgData = canvas.toDataURL("image/png");

                const link = document.createElement("a");
                link.href = imgData;
                link.download = `deposit_qr_code_${toFixed(
                  amount,
                )}_${currency}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
              // return false เพื่อไม่ให้ Swal ปิดอัตโนมัติ
              return false;
            },
            background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
            color: mode === "dark" ? "#fff" : "#000000", // Text color
            confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
            cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
          });
        } else {
          alert("#", "success");
        }
      }
    } else {
      alert(
        "",
        "warning",
        "Warning",
        result?.message || "An error occurred. Please try again.",
      );
    }
    loading(false);
  };
  // ---------- primerlo KYC widget (Create Payment) ----------
  MountPrimerloKyc = async (url) => {
    this.DestroyPrimerloWidget();
    if (!url) {
      this.setState({ primerlo_kyc: { ...this.state.primerlo_kyc, message: "Primerlo did not return a widget link. Please try again." } });
      return;
    }
    try {
      const DealerWidget = await loadPrimerloSdk();
      this.primerloWidget = DealerWidget.mount({ url, container: "#primerlo-kyc-widget", onEvent: this.OnPrimerloKycEvent });
    } catch (err) {
      console.error("mount primerlo kyc widget failed:", err?.message || err);
      this.setState({ primerlo_kyc: { ...this.state.primerlo_kyc, message: "Unable to load the Primerlo widget. Please try again." } });
    }
  };
  DestroyPrimerloWidget = () => {
    try {
      if (this.primerloWidget?.destroy) this.primerloWidget.destroy();
    } catch (e) {}
    this.primerloWidget = null;
  };
  ClosePrimerloKyc = () => {
    this.DestroyPrimerloWidget();
    this.setState({ primerlo_kyc: null });
  };
  // ขอ session kyc ใหม่จาก Backend (widgetUrl เปิดได้ครั้งเดียว) คืน widget_url หรือ null
  RequestPrimerloKycUrl = async () => {
    const { customer_id, payment_type, amount, ref_no, client_id, client_secret, client_ref_id, x_apigw_api_id, currency } = this.state;
    const result = await POST(`transactions/${payment_type}/partner`, {
      customer_id,
      amount,
      ref_no,
      client_id,
      client_secret,
      client_ref_id,
      "x-apigw-api-id": x_apigw_api_id,
      currency,
    });
    return result?.status && result?.data?.mode === "kyc" ? result.data.widget_url || null : null;
  };
  OnPrimerloKycEvent = async (m) => {
    if (!m || m.type !== "dealer.widget") return;
    switch (m.event) {
      case "popup_required": {
        // browser ไม่ให้ทำ passkey/LINE ใน iframe ต้องเปิดเป็น popup ด้วย session ใหม่
        this.DestroyPrimerloWidget();
        loading(true);
        const url = await this.RequestPrimerloKycUrl();
        loading(false);
        if (url && window.DealerWidget?.open) {
          this.primerloWidget = window.DealerWidget.open({ url, onEvent: this.OnPrimerloKycEvent });
        } else {
          this.setState({ primerlo_kyc: { ...this.state.primerlo_kyc, message: "This browser cannot run the verification inside the page. Please use Chrome or Safari." } });
        }
        break;
      }
      case "error":
        this.setState({ primerlo_kyc: { ...this.state.primerlo_kyc, message: `${m.data?.message || "Verification failed"}${m.data?.code ? ` (${m.data.code})` : ""}` } });
        break;
      case "closed": {
        this.DestroyPrimerloWidget();
        if (m.data?.reason === "done") {
          // ยืนยันตัวตนเสร็จ -> submit อีกรอบ Backend จะเช็คขั้น 1 ผ่านแล้วสร้างใบ (QR) ให้
          this.setState({ primerlo_kyc: null }, () => this.CreatePayment());
          return;
        }
        this.setState({ primerlo_kyc: { ...this.state.primerlo_kyc, message: "Verification was not completed. Click Retry to open the widget again." } });
        break;
      }
      default:
        break;
    }
  };
  ExportCertificate = async () => {
    const {
      client_id,
      client_ref_id,
      client_secret,
      x_apigw_api_id,
      ip_address,
      email,
    } = this.state;
    if (!ip_address?.length) {
      alert(
        "",
        "warning",
        "Warning",
        "There is no IP address for connecting to the API. Please contact the admin to add an IP address before requesting a certificate.",
      );
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to request a certificate?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      const body = {
        client_id: client_id,
        client_ref_id: client_ref_id,
        client_secret: client_secret,
        "x-apigw-api-id": x_apigw_api_id,
        valid_days: this.getDaysUntilEndOfYear(),
        ip_address: ip_address.toString(),
        email: email,
      };
      const result = await POST("certificates/create", body);
      if (result?.status) {
        alert(
          "#",
          "success",
          "Success",
          "Certificate created. The unzip password has been sent to the broker's email, and the broker can download certificate.zip from the Connect API page within 24 hours.",
        );
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  getDaysUntilEndOfYear() {
    const today = new Date();
    const currentYear = today.getFullYear();

    // ตั้งวันหมดอายุเป็น 30 มิถุนายนของปีปัจจุบัน
    let expiryDate = new Date(currentYear, 5, 30); // เดือน 5 = มิถุนายน (index เริ่มจาก 0)

    // ถ้าน้อยกว่า 30 วัน ให้เลื่อนหมดอายุไปอีกปี
    const diffTime = expiryDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 30) {
      expiryDate = new Date(currentYear + 1, 5, 30); // 30 มิ.ย. ปีหน้า
    }

    const finalDiffTime = expiryDate - today;
    const finalDiffDays = Math.ceil(finalDiffTime / (1000 * 60 * 60 * 24));

    return finalDiffDays;
  }
  // แถวข้อมูลใน popup Detail: ค่าถูกซ่อนเป็นจุดก่อน มีปุ่มดู/ซ่อน และปุ่ม copy ต่อท้ายทุกแถว
  // (ค่าที่ไม่ลับอย่าง IP / Expired ให้โชว์เลย แต่ยังมีปุ่ม copy)
  CertDetailRow = ({ label, value, secret = true, wrap = false }) => {
    const raw = String(value ?? "").trim();
    const has_value = raw && raw !== "-";
    const shown = has_value ? escapeHtml(raw) : "-";
    const masked = has_value ? "•".repeat(raw.length) : "-";
    return `
      <div class="cert-row">
        <b class="cert-label">${escapeHtml(label)}:</b>
        <span class="cert-value${secret && has_value ? " is-masked" : ""}${wrap ? " is-wrap" : ""}"
              data-value="${shown}" data-masked="${masked}">${secret ? masked : shown}</span>
        ${
          has_value
            ? `<span class="cert-actions">
                ${
                  secret
                    ? `<button type="button" class="cert-btn cert-toggle" title="Show / Hide" aria-label="Show / Hide"><span class="icon">\uf06e</span></button>`
                    : ""
                }
                <button type="button" class="cert-btn cert-copy" title="Copy" aria-label="Copy"><span class="icon">\uf0c5</span></button>
                <small class="cert-copied">Copied</small>
              </span>`
            : ""
        }
      </div>`;
  };
  Detail = async (item) => {
    await this.GetByID(item.uid);
    setTimeout(() => {
      const Row = this.CertDetailRow;
      let unzip_password = "";
      try {
        unzip_password = this.state.password_certificate ? atob(this.state.password_certificate) : "";
      } catch (e) {
        unzip_password = "";
      }
      Swal.fire({
        title: "Certificate Information",
        html: `
          <div class="w-100 text-start text-14 cert-detail">
            ${Row({ label: "client_id", value: this.state.client_id })}
            ${Row({ label: "client_secret", value: this.state.client_secret })}
            ${Row({ label: "client_ref_id", value: this.state.client_ref_id })}
            ${Row({ label: "x-apigw-api-id", value: this.state.x_apigw_api_id })}
            ${Row({ label: "UNZIP Password", value: unzip_password })}
            ${Row({ label: "JKS password", value: window.location.href.includes("sandbox") ? "MIIEpAIBAAKCAQEAp" : "AdCYW5na29rMRAwTR" })}
            ${Row({ label: "Expired", value: this.state.expire_at ? format_date(this.state.expire_at, "dd/mm/yyyy", "en") : "", secret: false })}
            ${Row({ label: "IP Address", value: this.state.ip_address?.toString()?.replaceAll(",", ", "), secret: false, wrap: true })}
          </div>
        `,
        width: 960,
        customClass: { popup: "cert-detail-popup" },
        showConfirmButton: false,
        showCloseButton: true,
        background: mode === "dark" ? "#000000" : "#fff",
        color: mode === "dark" ? "#fff" : "#000000",
        confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
        cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
        didOpen: (popup) => {
          popup.querySelectorAll(".cert-row").forEach((row) => {
            const value_el = row.querySelector(".cert-value");
            const toggle = row.querySelector(".cert-toggle");
            const copy = row.querySelector(".cert-copy");
            const copied = row.querySelector(".cert-copied");
            if (toggle) {
              toggle.addEventListener("click", () => {
                const is_masked = value_el.classList.toggle("is-masked");
                value_el.textContent = is_masked ? value_el.dataset.masked : value_el.dataset.value;
                toggle.querySelector(".icon").textContent = is_masked ? "\uf06e" : "\uf070";
              });
            }
            if (copy) {
              copy.addEventListener("click", async () => {
                // ใช้ writeClipboard แทน copyText เพราะ copyText เปิด Swal ใหม่ซึ่งจะปิด popup นี้
                const ok = await writeClipboard(value_el.dataset.value);
                if (!ok || !copied) return;
                copied.classList.add("show");
                clearTimeout(copied._t);
                copied._t = setTimeout(() => copied.classList.remove("show"), 1200);
              });
            }
          });
        },
      });
    }, 10);
  };
  DownloadCertificate = async () => {
    const { link } = this.state;
    try {
      let base64 = link.split(":")[1];

      // ✅ แก้ช่องว่างและตัวอักษรไม่ถูกต้องก่อน decode
      base64 = base64?.replace(/ /g, "+")?.replace(/%2B/g, "+")?.replace(/\r?\n|\s/g, "");

      // แปลง Base64 → Binary
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // สร้าง Blob ZIP
      const blob = new Blob([byteArray], {
        type: "application/zip",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "certificate.zip";
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert(
        "",
        "warning",
        "Warning",
        "The file you want to download was not found.",
      );
      console.error(err);
    }
  };
  // Tint a broker row by its certificate expiry: red once expired, yellow when
  // it is within 30 days of expiring. Uses --bs-table-bg so it wins over the
  // table's column striping.
  expireRowStyle = (item) => {
    const exp = item.entity_config?.expire_at;
    if (!exp) return {};
    const days = (new Date(exp) - new Date()) / (1000 * 60 * 60 * 24);
    if (days < 0) return { "--bs-table-bg": "#fde8e8" };
    if (days <= 30) return { "--bs-table-bg": "#fff8e6" };
    return {};
  };
  // Resolve the deposit/withdraw gateway a broker uses for a given currency:
  // gateway_active holds the gateway_code per currency, data_gateway maps that
  // code to a display name, and gateway_register holds the merchant id + fee.
  gatewayCellInfo = (item, currency, type) => {
    const { data_gateway } = this.state;
    const active = item.gateway_active?.find((e) => e.currency === currency);
    const code =
      type === "deposit"
        ? active?.gateway_deposits
        : active?.gateway_withdrawals;
    if (!code) return null;
    const name = data_gateway?.find((g) => g.value === code)?.label || code;
    const reg = item.gateway_register?.find(
      (r) => r.gateway_name === name || r.gateway_name === code,
    );
    const feeType =
      type === "deposit" ? reg?.deposit_fee_type : reg?.withdrawal_fee_type;
    const feeValue =
      type === "deposit" ? reg?.deposit_fee_value : reg?.withdrawal_fee_value;
    const feeText =
      feeValue !== undefined && feeValue !== null && feeValue !== ""
        ? `${Number(feeValue)}${feeType === "percentage" ? "%" : ` ${currency}`}`
        : "";
    return {
      code,
      name,
      merchant_id: reg?.merchant_id || "",
      bank_name: reg?.bank_account_name_th || "",
      feeText,
    };
  };
  renderGatewayCell = (item, type) => {
    const { filter_currency } = this.state;
    const g = this.gatewayCellInfo(item, filter_currency, type);
    // THB shows the merchant id, LAK shows the bank account name (TH).
    const desc =
      filter_currency === "LAK" ? g?.bank_name : g?.merchant_id;
    return (
      <td
        data-label={type === "deposit" ? "Deposit Gateway" : "Withdraw Gateway"}
        className="text-nowrap py-1"
      >
        {g ? (
          <div className="pu-gateway">
            {/* gateway ที่ยังไม่มีรูป GatewayLogo จะ fallback เป็นวงกลมตัวอักษรแรกให้เอง */}
            <GatewayLogo name={g.code} size={26} />
            <div className="min-w-0">
              <div className="pu-gateway-name">
                <span className="text-truncate">{g.name}</span>
                {g.feeText ? <span className="pu-fee-chip">{g.feeText}</span> : null}
              </div>
              <div className="pu-sub pu-mono">{desc || "-"}</div>
            </div>
          </div>
        ) : (
          <span className="pu-none">-</span>
        )}
      </td>
    );
  };
  // ค่าเริ่มต้นของฟอร์มสร้าง broker (ยกมาจากปุ่ม Create Broker เดิมโดยไม่แก้ค่าใด ๆ)
  openCreate = () => {
    const { data_gateway } = this.state;
    this.setState({
        filter_currency: "THB",
        id: "",
        uid: "",
        agent_id: "",
        name_th: "",
        name_en: "",
        email: "",
        phone: "",
        deposit_fee_type: "",
        deposit_fee_value: "",
        payment_min_deposit: 0,
        withdrawal_fee_type: "",
        withdrawal_fee_value: "",
        payment_min_withdrawal: 0,
        is_vat: true,
        bank_code: "",
        bank_account_name_th: "",
        bank_account_name_en: "",
        bank_account_number: "",
        company_name: "",
        company_address: "",
        company_website: "",
        tax_number: "",
        contact_name: "",
        contact_email: "",
        contact_phone: "",
        remark: "",
        callback_url: "",
        return_url: "",
        return_url_withdrawal: "",
        callback_url_withdrawal: "",
        gateway: "",
        gateway_deposits: "payso",
        gateway_withdrawals: "",
        password: "",
        ip_address: [],
        ip_address_input: "",
        ip_address_error: "",
        show_gateway_secret: false,
        reveal_fields: {},
        collapsed_companies: {},
        edited_fields: {},
        is_mismatch_first_time: false,
        merchant_id: "",
        merchant_secret_key: "",
        apikey: "",
        authen_key: "",
        is_active: true,
        gateway_active: global.currency.map((e) => ({
            currency: e.currency_code,
            is_active: e.is_active,
            gateway_deposits: "",
            gateway_withdrawals: "",
            payment_min_deposit: 0,
            payment_min_withdrawal: 0,
        })),
        gateway_fee_rate: data_gateway?.map((e) => ({
            gateway_name: e.label,
            company_name: "",
            business_type: "",
            priority: 1,
            min_gmv_per_transaction: "",
            limit_gmv_per_transaction: "",
            limit_gmv_per_day: "",
            limit_gmv_per_month: "",
            credentials: {},
            deposit_fee_type: "percentage",
            deposit_fee_value: "",
            payment_min_deposit: 0,
            withdrawal_fee_type: "percentage",
            withdrawal_fee_value: "",
            payment_min_withdrawal: 0,
            is_vat: true,
            bank_code: "",
            bank_account_name_th: "",
            bank_account_name_en: "",
            bank_account_number: "",
            merchant_id: "",
            authen_key: "",
            merchant_secret_key: "",
            apikey: "",
            return_url: "",
            callback_url: "",
            return_url_withdrawal: "",
            callback_url_withdrawal: "",
            remark: "",
        })),
        filter_gateway: data_gateway[0]?.label || "",
        is_deposit_queue: false,
        is_withdrawal_queue: false,
        active_tab: "info",
        modal_create: true,
    });
  };
  render() {
    const {
      modal_create,
      modal_update,
      modal_update_wallet,
      modal_send_certificate,
      modal_payment,
      primerlo_kyc,
      active_tab,
      filter_search,
      filter_gateway_name,
      filter_currency,
      filter_gateway,
      loaded,
      data,
      count,
      data_bank,
      data_agent,
      data_customer,
      customer_id,
      payment_type,
      amount,
      ref_no,
      uid,
      agent_id,
      name_th,
      name_en,
      email,
      phone,
      company_name,
      company_address,
      company_website,
      tax_number,
      contact_name,
      contact_email,
      contact_phone,
      room_notify_id,
      room_notify_slack_id,
      is_notify_balance_payout,
      password,
      ip_address,
      ip_address_input,
      ip_address_error,
      is_mismatch_first_time,
      gateway_active,
      gateway_fee_rate,
      show_gateway_secret,
      wallets,
      currency,
      link,

      is_deposit_queue,
      is_withdrawal_queue,

      deposit_commission_type,
      deposit_commission_value,
      withdrawal_commission_type,
      withdrawal_commission_value,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    return (
        <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
            <Navbar />
            <div className="body p-3 mt-3">
                {/* HERO */}
                <div className="ar-hero mb-4">
                    <div className="ar-hero-head">
                        <div>
                            <div className="ar-eyebrow mb-1">Management</div>
                            <div className="ar-title">Broker Management</div>
                            <div className="ar-subtitle">Manage broker accounts, gateways and the financial overview per currency.</div>
                        </div>
                        <div className="ar-hero-actions">
                            <button className="ar-btn-gold brokers.create" onClick={this.openCreate}>
                                <span className="icon me-2">{"\uf234"}</span>Create Broker
                            </button>
                        </div>
                    </div>

                    <div className="ar-toolbar ar-filter mt-3">
<div className="ar-filter-head">
<span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
</div>
<div className="ar-filter-row">
<div className="ar-filter-field ar-filter-field-search">
<span className="ar-filter-label">Search</span>
<input
                            type="text"
                            className="form-control wpx-220"
                            placeholder="Search broker name, email..."
                            onChange={(e) => {
                                this.setState({ filter_search: e.target.value });
                            }}
                            onKeyUp={(e) => {
                                if (e.key === "Enter") {
                                    this.Get(1);
                                }
                            }}
                            value={filter_search}
                        />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Gateway</span>
<Select
                                className="form-control"
                                placeholder="All gateways"
                                options={this.GatewayFilterOptions()}
                                value={filter_gateway_name}
                                onChange={(v) => {
                                    this.setState({ filter_gateway_name: v }, () => this.Get(1));
                                }}
                                default={false}
                            />
</div>
<div className="ar-toolbar-actions">
                        <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                            <span className="icon me-2">{"\uf002"}</span>Search
                        </button>
                        <button
                            className="ar-btn-ghost"
                            onClick={() =>
                                this.setState(
                                    {
                                        filter_search: params("search") || "",
                                        filter_currency: "THB",
                                        filter_gateway_name: "",
                                    },
                                    () => this.Get(1)
                                )
                            }
                        >
                            Reset
                        </button>
                        </div>
</div>
<div className="ar-filter-foot">
<div className="d-flex align-items-center gap-2 flex-wrap">
                            {global.currency?.map((item) => (
                                <button
                                    key={item.currency_code}
                                    className={`ar-pill ${item.currency_code === filter_currency ? "active" : ""}`}
                                    onClick={() => {
                                        // gateway ผูกกับสกุลเงิน ตัวที่เลือกไว้จึงใช้กับสกุลใหม่ไม่ได้
                                        // ไม่ล้างทิ้งจะได้ผลว่างโดยที่คนกดไม่รู้ว่าเพราะอะไร
                                        this.setState({ filter_currency: item.currency_code, filter_gateway_name: "" });
                                        setTimeout(() => {
                                            this.Get(1);
                                        }, 100);
                                    }}
                                >
                                    {item.image}
                                    {item.currency_code}
                                </button>
                            ))}
                        </div>
</div>
</div>
                </div>

                {/* TABLE */}
                <div className="ar-table-card">
                    <div className="ar-table-head">
                        <div>
                            <div className="ar-table-title">
                                <span className="icon me-2 pu-title-icon">{"\uf1ad"}</span>
                                Brokers
                                <span className="pu-currency-tag">{filter_currency}</span>
                            </div>
                            <div className="ar-table-caption">
                                {count || 0} broker{count === 1 ? "" : "s"} · showing {rows.length} on this page
                            </div>
                        </div>
                        <div className="ar-legend d-none d-md-flex align-items-center gap-3">
                            <span>
                                <span className="pu-legend-dot on" />
                                Active
                            </span>
                            <span>
                                <span className="pu-legend-dot off" />
                                Inactive
                            </span>
                            <span>
                                <span className="pu-legend-swatch" />
                                Expires within 30 days
                            </span>
                            <span>
                                <span className="pu-legend-swatch expired" />
                                Expired
                            </span>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ minHeight: 400 }}>
                        <table className="table table-hover ar-table pu-table pu-table-compact">
                            <thead>
                                <tr>
                                    <td className="wpx-60 text-center">Tier</td>
                                    <td className="text-nowrap">Broker</td>
                                    <td className="text-nowrap">Deposit Gateway</td>
                                    <td className="text-nowrap">Withdraw Gateway</td>
                                    <td className="text-nowrap">Deposits</td>
                                    <td className="text-nowrap">Withdrawals</td>
                                    <td className="text-nowrap">Fee</td>
                                    <td className="text-nowrap">Vat</td>
                                    <td className="text-end text-nowrap">Balance</td>
                                    <td className="text-end text-nowrap">Available Balance</td>
                                    <td className="text-center text-nowrap wpx-100">Status</td>
                                    <td className="text-center text-nowrap brokers.update td-actions">Actions</td>
                                </tr>
                            </thead>
                            <tbody>
                                {loaded && rows.length === 0 && (
                                    <tr>
                                        <td colSpan={12} className="p-0 border-0">
                                            <div className="pr-empty rounded-0 border-0">
                                                <span className="icon">{"\uf1ad"}</span>
                                                <div className="fw-bold">No brokers found</div>
                                                <div className="text-secondary text-14">Try another search, currency or gateway.</div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {rows.map((item, index) => {
                                    const tier = item.tiers?.find((e) => e.is_active && e.currency === filter_currency);
                                    const active = item.gateway_active?.find((e) => e.currency === filter_currency);
                                    const wallet = item.wallets?.find((e) => e.currency === filter_currency);
                                    const name = item.name_en || item.name_th || "-";
                                    return (
                                        <tr key={item.uid || `array-${index}`} style={this.expireRowStyle(item)}>
                                            <td data-label="Tier" className="text-center">
                                                <span className={`pu-tier ${tier ? "" : "off"}`} title={tier?.tier_name || "No tier"}>
                                                    <img alt={tier?.tier_name || ""} src={RANK_IMAGES[tier?.sequence] || RANK1} width={22} />
                                                </span>
                                            </td>
                                            <td data-label="Broker" className="text-nowrap">
                                                <div className="pu-user">
                                                    <div className="min-w-0">
                                                        <div className="pu-name text-truncate" title={name}>
                                                            {name}
                                                        </div>
                                                        {item.name_en && item.name_th && (
                                                            <div className="pu-sub">
                                                                <span className="text-truncate">{item.name_th}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                            {this.renderGatewayCell(item, "deposit")}
                                            {this.renderGatewayCell(item, "withdraw")}
                                            <td data-label="Deposits" className="text-nowrap">
                                                <div className="pu-amount">{toFixed(active?.total_deposits || 0, 2) || "0.00"}</div>
                                                <div className={`pu-orders ${active?.order_deposits ? "has" : ""}`}>{active?.order_deposits || 0} orders</div>
                                            </td>
                                            <td data-label="Withdrawals" className="text-nowrap">
                                                <div className="pu-amount">{toFixed(active?.total_withdrawals || 0, 2) || "0.00"}</div>
                                                <div className={`pu-orders ${active?.order_withdrawals ? "has" : ""}`}>{active?.order_withdrawals || 0} orders</div>
                                            </td>
                                            <td data-label="Fee" className="text-nowrap pu-num">
                                                {toFixed(active?.total_fee || 0, 2) || "0.00"}
                                            </td>
                                            <td data-label="Vat" className="text-nowrap pu-num">
                                                {toFixed(active?.total_vat || 0, 2) || "0.00"}
                                            </td>
                                            <td data-label="Balance" className="text-end text-nowrap">
                                                <div className="pu-amount">{wallet?.balance ? toFixed(wallet.balance, 2) : "0.00"}</div>
                                            </td>
                                            <td data-label="Available Balance" className="text-end text-nowrap">
                                                <div className="pu-amount pu-amount-gold">{wallet?.balance_t1 ? toFixed(wallet.balance_t1, 2) : "0.00"}</div>
                                            </td>
                                            <td data-label="Status" className="text-nowrap text-center">
                                                <span className={`pr-status ${item.is_active ? "on" : "off"}`}>{item.is_active ? "Active" : "Inactive"}</span>
                                            </td>
                                            <td data-label="Actions" className="text-center brokers.update td-actions">
                                                <Dropdown align="end">
                                                    <Dropdown.Toggle className="pu-action-toggle" id={`broker-actions-${index}`}>
                                                        Action
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                                        <Dropdown.Item
                                                            className="pu-action-item brokers.update"
                                                            onClick={async () => {
                                                                await this.GetByID(item.uid);
                                                                this.setState({ modal_update: true, active_tab: "info" });
                                                            }}
                                                        >
                                                            <span className="icon">{"\uf044"}</span>Update
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            className="pu-action-item brokers.update"
                                                            onClick={async () => {
                                                                await this.GetByID(item.uid);
                                                                this.setState({ modal_update_wallet: true });
                                                            }}
                                                        >
                                                            <span className="icon">{"\uf555"}</span>Update Wallet
                                                        </Dropdown.Item>
                                                        {profile.user_type === "super_user" && (
                                                            <>
                                                                <div className="pu-action-sep" />
                                                                <Dropdown.Item
                                                                    className="pu-action-item"
                                                                    onClick={async () => {
                                                                        await this.GetByID(item.uid);
                                                                        this.setState(
                                                                            {
                                                                                modal_payment: true,
                                                                                customer_id: "",
                                                                                payment_type: "deposits",
                                                                                amount: "",
                                                                                ref_no: "",
                                                                                currency: "THB",
                                                                                filter_currency: "THB",
                                                                            },
                                                                            () => {
                                                                                this.GetCustomer();
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <span className="icon">{"\uf53d"}</span>Deposit &amp; Withdraw
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    className="pu-action-item"
                                                                    onClick={async () => {
                                                                        await this.RecalWallet(item.uid);
                                                                    }}
                                                                >
                                                                    <span className="icon">{"\uf2f1"}</span>Recal Balance
                                                                </Dropdown.Item>
                                                            </>
                                                        )}
                                                        <div className="pu-action-sep" />
                                                        <Dropdown.Item
                                                            className="pu-action-item"
                                                            onClick={() => {
                                                                this.Detail(item);
                                                            }}
                                                        >
                                                            <span className="icon">{"\uf06e"}</span>Detail
                                                        </Dropdown.Item>
                                                        {profile.user_type === "super_user" && (
                                                            <Dropdown.Item
                                                                className="pu-action-item"
                                                                onClick={async () => {
                                                                    await this.GetByID(item.uid);
                                                                    this.setState({
                                                                        modal_send_certificate: true,
                                                                    });
                                                                }}
                                                            >
                                                                <span className="icon">{"\uf5bf"}</span>Send Certificate
                                                            </Dropdown.Item>
                                                        )}
                                                        <Dropdown.Item
                                                            className="pu-action-item brokers.update"
                                                            onClick={async () => {
                                                                await this.GetByID(item.uid);
                                                                setTimeout(() => {
                                                                    this.DownloadCertificate();
                                                                }, 100);
                                                            }}
                                                        >
                                                            <span className="icon">{"\uf019"}</span>Download Certificate
                                                        </Dropdown.Item>
                                                        {!item.is_active && profile.user_type === "super_user" && (
                                                            <>
                                                                <div className="pu-action-sep" />
                                                                <Dropdown.Item
                                                                    className="pu-action-item danger brokers.delete"
                                                                    onClick={async () => {
                                                                        this.Delete(item.uid);
                                                                    }}
                                                                >
                                                                    <span className="icon">{"\uf2ed"}</span>Delete
                                                                </Dropdown.Item>
                                                            </>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
                    <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
                </div>
            </div>
            {/* CREATE UPDATE */}
            <Modal show={modal_create || modal_update} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_create: false, modal_update: false })} size={"xl"}>
                <Modal.Header className="pr-modal-header" closeButton>
                    <div>
                        <div className="pr-modal-eyebrow">{modal_create ? "New broker" : "Edit broker"}</div>
                        <h5 className="fw-bold mb-0">{modal_create ? "Create" : modal_update ? "Update" : ""} Broker</h5>
                    </div>
                </Modal.Header>
                <Modal.Body className="pr-modal-body">
                    {/* Tabs */}
                    <div className="pu-tabs">
                        {[
                            { key: "info", label: "Information", icon: "\uf2bd" },
                            { key: "commission", label: "Agent", icon: "\uf508" },
                            { key: "gateway", label: "Gateway", icon: "\uf6ff" },
                            { key: "payment", label: "Payment", icon: "\uf53d" },
                            { key: "api", label: "API", icon: "\uf121" },
                        ].map((t) => (
                            <button
                                key={t.key}
                                type="button"
                                className={`pu-tab ${active_tab === t.key ? "active" : ""}`}
                                onClick={() => this.setState({ active_tab: t.key })}
                            >
                                <span className="icon me-2">{t.icon}</span>
                                {t.label}
                            </button>
                        ))}
                    </div>
                    {/* Commission Agent */}
                    <div className={active_tab === "commission" ? "" : "d-none"}>
                        <div className="mb-3">
                            <div className="pu-modal-heading">Commission Agent</div>
                            <div className="row">
                                <div className="col-12 col-lg-6 d-flex align-items-center mb-3">
                                    <div className="wpx-130 mt-2">Agent</div>
                                    <Select
                                        className="form-control"
                                        placeholder="Agent..."
                                        options={data_agent}
                                        onChange={(e) => {
                                            this.setState({ agent_id: e });
                                        }}
                                        value={agent_id}
                                    ></Select>
                                </div>
                                <div className="col-12 col-lg-6 d-flex align-items-center mb-3"></div>
                                <div className="col-12 col-lg-6 d-flex align-items-center mb-3">
                                    <div className="wpx-130 mt-2">Deposits</div>
                                    <div className="position-relative w-100">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Deposits..."
                                            onChange={(e) => {
                                                if (!float(e.target.value, 4)) return;
                                                this.setState({ deposit_commission_value: e.target.value });
                                            }}
                                            value={deposit_commission_value}
                                        />
                                        <span className="position-absolute text-secondary" style={{ right: 12, top: 6 }}>
                                            {deposit_commission_type === "percentage" ? "%" : "THB"}
                                        </span>
                                    </div>
                                    <div className="d-flex ms-2" style={{ padding: 1, borderRadius: 12, border: "1px #d2d2d2 solid" }}>
                                        <button
                                            type="button"
                                            className={`btn ${deposit_commission_type === "percentage" ? "btn-dark" : "btn-light"} me-1`}
                                            onClick={() => this.setState({ deposit_commission_type: "percentage" })}
                                        >
                                            %
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${deposit_commission_type === "fixed" ? "btn-dark" : "btn-light"}`}
                                            onClick={() => this.setState({ deposit_commission_type: "fixed" })}
                                        >
                                            THB
                                        </button>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 d-flex align-items-center mb-3">
                                    <div className="wpx-130 mt-2">Withdrawal</div>
                                    <div className="position-relative w-100">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Withdrawal..."
                                            onChange={(e) => {
                                                if (!float(e.target.value, 4)) return;
                                                this.setState({ withdrawal_commission_value: e.target.value });
                                            }}
                                            value={withdrawal_commission_value}
                                        />
                                        <span className="position-absolute text-secondary" style={{ right: 12, top: 6 }}>
                                            {withdrawal_commission_type === "percentage" ? "%" : "THB"}
                                        </span>
                                    </div>
                                    <div className="d-flex ms-2" style={{ padding: 1, borderRadius: 12, border: "1px #d2d2d2 solid" }}>
                                        <button
                                            type="button"
                                            className={`btn ${withdrawal_commission_type === "percentage" ? "btn-dark" : "btn-light"} me-1`}
                                            onClick={() => this.setState({ withdrawal_commission_type: "percentage" })}
                                        >
                                            %
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${withdrawal_commission_type === "fixed" ? "btn-dark" : "btn-light"}`}
                                            onClick={() => this.setState({ withdrawal_commission_type: "fixed" })}
                                        >
                                            THB
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {/* Basic Information */}
                        <div className={`col-12 col-xl-6 mb-3 ${active_tab === "info" ? "" : "d-none"}`}>
                            <div className="pu-section h-100 mb-0">
                                <div className="pu-section-title">Basic Information</div>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        {this.FormField({
                                            label: <>Name TH{required}</>,
                                            placeholder: "Name TH...",
                                            value: name_th,
                                            onChange: (e) => this.setState({ name_th: e.target.value }),
                                        })}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        {this.FormField({
                                            label: <>Name EN{required}</>,
                                            placeholder: "Name EN...",
                                            value: name_en,
                                            onChange: (e) => this.setState({ name_en: e.target.value }),
                                        })}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        {this.FormField({
                                            label: <>Phone{required}</>,
                                            placeholder: "Phone...",
                                            maxLength: 10,
                                            value: phone,
                                            onChange: (e) => {
                                                if (!float(e.target.value)) return;
                                                this.setState({ phone: e.target.value });
                                            },
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Company Information */}
                        <div className={`col-12 col-xl-6 mb-3 ${active_tab === "info" ? "" : "d-none"}`}>
                            <div className="pu-section h-100 mb-0">
                                <div className="pu-section-title">Company Information</div>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        {this.FormField({
                                            label: <>Company Name{required}</>,
                                            placeholder: "Company Name...",
                                            value: company_name,
                                            onChange: (e) => this.setState({ company_name: e.target.value }),
                                        })}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        {this.FormField({
                                            label: "Company Tax",
                                            placeholder: "Company Tax...",
                                            value: tax_number,
                                            onChange: (e) => {
                                                if (!float(e.target.value)) return;
                                                this.setState({ tax_number: e.target.value });
                                            },
                                        })}
                                    </div>
                                    <div className="col-12">
                                        {this.FormField({
                                            label: <>Company Address{required}</>,
                                            placeholder: "Company Address...",
                                            value: company_address,
                                            onChange: (e) => this.setState({ company_address: e.target.value }),
                                        })}
                                    </div>
                                    <div className="col-12">
                                        {this.FormField({
                                            label: <>Company Website{required}</>,
                                            placeholder: "https://...",
                                            copy: true,
                                            value: company_website,
                                            onChange: (e) => this.setState({ company_website: e.target.value }),
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Contact Information */}
                        <div className={`col-12 col-xl-6 mb-3 ${active_tab === "info" ? "" : "d-none"}`}>
                            <div className="pu-section h-100 mb-0">
                                <div className="pu-section-title">Contact Information</div>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        {this.FormField({
                                            label: <>Contact Name{required}</>,
                                            placeholder: "Contact Name...",
                                            value: contact_name,
                                            onChange: (e) => this.setState({ contact_name: e.target.value }),
                                        })}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        {this.FormField({
                                            label: <>Contact Phone{required}</>,
                                            placeholder: "Contact Phone...",
                                            maxLength: 10,
                                            value: contact_phone,
                                            onChange: (e) => {
                                                if (!float(e.target.value)) return;
                                                this.setState({ contact_phone: e.target.value });
                                            },
                                        })}
                                    </div>
                                    <div className="col-12">
                                        {this.FormField({
                                            label: <>Contact Email{required}</>,
                                            type: "email",
                                            placeholder: "Contact Email...",
                                            copy: true,
                                            value: contact_email,
                                            onChange: (e) => this.setState({ contact_email: e.target.value }),
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Account Information */}
                        {modal_create && (
                            <div className={`col-12 col-xl-6 mb-3 ${active_tab === "info" ? "" : "d-none"}`}>
                                <div className="pu-section h-100 mb-0">
                                    <b className="d-block mb-1">Account Information</b>
                                    <small className="text-secondary d-block mb-3">Used by the broker to sign in.</small>
                                    <div className="row">
                                        <div className="col-12">
                                            {this.FormField({
                                                label: <>Email{required}</>,
                                                placeholder: "Email...",
                                                value: email,
                                                onChange: (e) => this.setState({ email: e.target.value }),
                                            })}
                                        </div>
                                        <div className="col-12">
                                            {this.FormField({
                                                label: <>Password{required}</>,
                                                value: password,
                                                copy: true,
                                                children: (
                                                    <div className="d-flex">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Password..."
                                                            onChange={(e) => {
                                                                this.setState({ password: e.target.value });
                                                            }}
                                                            value={password}
                                                        />
                                                        <button
                                                            className="btn btn-dark ms-2 px-3 text-nowrap"
                                                            onClick={() => {
                                                                const text = random_charactor(12);
                                                                this.setState({ password: text });
                                                            }}
                                                        >
                                                            Generate
                                                        </button>
                                                    </div>
                                                ),
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* API Information */}
                        {(modal_create || modal_update) && (
                            <div className={`col-12 mb-3 ${active_tab === "api" ? "" : "d-none"}`}>
                                <div className="pu-modal-heading">API Information</div>
                                {/* Whitelist: one input adds one or many addresses,
                                    each stored as a removable chip. */}
                                <div className="pu-section">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <b>IP Whitelist</b>
                                        <div className="d-flex align-items-center">
                                            <small className="text-secondary">{ip_address.length} address{ip_address.length === 1 ? "" : "es"}</small>
                                            {ip_address.length > 0 && (
                                                <button
                                                    className="btn btn-link text-danger text-decoration-none p-0 ms-3"
                                                    onClick={() => this.RemoveAllIpAddress()}
                                                >
                                                    Remove All
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <input
                                            type="text"
                                            className={`form-control ${ip_address_error ? "border-danger" : ""}`}
                                            placeholder="192.168.1.2 or 192.168.1.0/24"
                                            onChange={(e) => {
                                                this.setState({ ip_address_input: e.target.value, ip_address_error: "" });
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key !== "Enter") return;
                                                e.preventDefault();
                                                this.AddIpAddress(ip_address_input);
                                            }}
                                            onPaste={(e) => {
                                                const text = (e.clipboardData || window.clipboardData).getData("text");
                                                // A single address is left to type normally; a list is added at once.
                                                if (!text || !/[\s,;]/.test(text.trim())) return;
                                                e.preventDefault();
                                                this.AddIpAddress(text);
                                            }}
                                            value={ip_address_input}
                                        />
                                        <button
                                            className="btn btn-dark ms-2 px-4 text-nowrap"
                                            onClick={() => this.AddIpAddress(ip_address_input)}
                                        >
                                            Add
                                        </button>
                                    </div>
                                    {ip_address_error ? (
                                        <small className="text-danger">{ip_address_error}</small>
                                    ) : (
                                        <small className="text-secondary">
                                            ** Press Enter or click Add. Paste several at once: 192.168.1.2, 192.168.1.3
                                        </small>
                                    )}
                                    <div className="d-flex flex-wrap mt-3">
                                        {ip_address.length === 0 ? (
                                            <small className="text-secondary">No IP address yet. Every IP is allowed until one is added.</small>
                                        ) : (
                                            ip_address.map((item, index) => (
                                                <span
                                                    key={item}
                                                    className="d-flex align-items-center bg-light border me-2 mb-2 ps-3 pe-2 py-1"
                                                    style={{ borderRadius: 20 }}
                                                >
                                                    {item}
                                                    <span
                                                        className="icon text-danger pointer ms-2 text-18"
                                                        onClick={() => this.RemoveIpAddress(index)}
                                                    >
                                                        {"\uf00d"}
                                                    </span>
                                                </span>
                                            ))
                                        )}
                                    </div>
                                </div>

                                <div className="pu-section">
                                    <b className="d-block mb-2">Notification</b>
                                    <div className="row">
                                        <div className="col-12 col-md-6 d-flex mb-3">
                                            <div className="wpx-130 mt-2">Telegram Chat ID</div>
                                            <input
                                                type="phone"
                                                className="form-control"
                                                placeholder="Telegram Chat ID..."
                                                onChange={(e) => {
                                                    this.setState({ room_notify_id: e.target.value });
                                                }}
                                                value={room_notify_id}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 d-flex mb-3">
                                            <div className="wpx-130 mt-2">Slack Chat ID</div>
                                            <input
                                                type="phone"
                                                className="form-control"
                                                placeholder="Slack Chat ID..."
                                                onChange={(e) => {
                                                    this.setState({ room_notify_slack_id: e.target.value });
                                                }}
                                                value={room_notify_slack_id}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Switch
                                            onChange={(e) => {
                                                this.setState({
                                                    is_notify_balance_payout: e,
                                                });
                                            }}
                                            checked={is_notify_balance_payout}
                                        />
                                        <div className="ms-2">Notify Balance</div>
                                    </div>
                                </div>

                                <div className="pu-section">
                                    <b className="d-block mb-2">Transaction Behavior</b>
                                    <div className="d-flex align-items-center">
                                        <Switch
                                            onChange={(e) => {
                                                this.setState({
                                                    is_mismatch_first_time: e,
                                                });
                                            }}
                                            checked={is_mismatch_first_time}
                                        />
                                        <div className="ms-2">MisMatch First Time</div>
                                    </div>
                                    <small className="text-secondary">
                                        If inactive, the system will give the second or more transactions of the same customer as mismatches, but the first transaction will be a normal success.
                                    </small>
                                </div>
                            </div>
                        )}
                        {/* Payment Information */}
                        <div className={`col-12 mb-3 ${active_tab === "payment" ? "" : "d-none"}`}>
                            <div className="pu-modal-heading">Payment Information</div>
                            <div className="d-flex mb-2">
                                {global.currency?.map((item) => (
                                    <button
                                        key={item.currency_code}
                                        type="button"
                                        className={`pu-seg ${item.currency_code === filter_currency ? "active" : ""}`}
                                        onClick={() => {
                                            this.setState({ filter_currency: item.currency_code });
                                        }}
                                    >
                                        {item.image}
                                        {item.currency_name}
                                    </button>
                                ))}
                            </div>
                            {/* GATEWAY */}
                            {gateway_active.map(
                                (gw_item, index) =>
                                    gw_item.currency === filter_currency && (
                                        <div className="row">
                                            {/* Deposit */}
                                            <div className="col-12 col-lg-6">
                                                <div className="d-flex mb-3">
                                                    <div className="wpx-130 mt-2">Deposit Gateway</div>
                                                    <Select
                                                        className="form-control"
                                                        placeholder="Deposit Gateway..."
                                                        options={this.GatewayOptions(gw_item.currency)}
                                                        onChange={(v) => {
                                                            let _gateway_active = gateway_active;
                                                            _gateway_active[index].gateway_deposits = v;
                                                            this.setState({
                                                                gateway_active: _gateway_active,
                                                            });
                                                        }}
                                                        value={gw_item.gateway_deposits}
                                                        default={false}
                                                    />
                                                </div>
                                                {/* Deposit Detail */}
                                                {gateway_fee_rate?.map(
                                                    (gfr_item, gfr_index) =>
                                                        gfr_item.gateway_name === gw_item.gateway_deposits && (
                                                            <div className="row">
                                                                <div className="d-flex align-items-center mb-3">
                                                                    <div className="wpx-130 mt-2">Deposit Fee Rate{required}</div>

                                                                    <div className="position-relative w-100">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Deposit Fee Rate..."
                                                                            onChange={(e) => {
                                                                                if (!float(e.target.value, 4)) return;
                                                                                let _gateway_fee_rate = gateway_fee_rate;
                                                                                _gateway_fee_rate[gfr_index].deposit_fee_value = e.target.value;
                                                                                this.MarkEdited(gfr_index, "deposit_fee");
                                                                                this.setState({
                                                                                    gateway_fee_rate: _gateway_fee_rate,
                                                                                });
                                                                            }}
                                                                            value={gfr_item.deposit_fee_value}
                                                                        />
                                                                        <span className="position-absolute text-secondary" style={{ right: 12, top: 6 }}>
                                                                            {gfr_item.deposit_fee_type === "percentage" ? "%" : gw_item.currency}
                                                                        </span>
                                                                    </div>

                                                                    <div
                                                                        className="border-1 border-gray d-flex ms-2"
                                                                        style={{
                                                                            padding: 1,
                                                                            borderRadius: 12,
                                                                            border: "1px #d2d2d2 solid",
                                                                        }}
                                                                    >
                                                                        <button
                                                                            className={`btn ${gfr_item.deposit_fee_type === "percentage" ? "btn-dark" : "btn-light"} me-1`}
                                                                            onClick={() => {
                                                                                let _gateway_fee_rate = gateway_fee_rate;
                                                                                _gateway_fee_rate[gfr_index].deposit_fee_type = "percentage";
                                                                                this.MarkEdited(gfr_index, "deposit_fee");
                                                                                this.setState({
                                                                                    gateway_fee_rate: _gateway_fee_rate,
                                                                                });
                                                                            }}
                                                                        >
                                                                            %
                                                                        </button>
                                                                        <button
                                                                            className={`btn ${gfr_item.deposit_fee_type === "fixed" ? "btn-dark" : "btn-light"}`}
                                                                            onClick={() => {
                                                                                let _gateway_fee_rate = gateway_fee_rate;
                                                                                _gateway_fee_rate[gfr_index].deposit_fee_type = "fixed";
                                                                                this.MarkEdited(gfr_index, "deposit_fee");
                                                                                this.setState({
                                                                                    gateway_fee_rate: _gateway_fee_rate,
                                                                                });
                                                                            }}
                                                                        >
                                                                            {gw_item.currency}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                {this.ApplyAllButton(gfr_index, "deposit_fee", gw_item.currency) && (
                                                                    <div className="d-flex" style={{ marginTop: -12, marginBottom: 12 }}>
                                                                        <div className="wpx-130" />
                                                                        {this.ApplyAllButton(gfr_index, "deposit_fee", gw_item.currency)}
                                                                    </div>
                                                                )}
                                                                <div className="d-flex mb-3">
                                                                    <div className="wpx-130 mt-2">Min Deposit</div>
                                                                    <div className="position-relative w-100">
                                                                        <NumericFormat
                                                                            thousandSeparator=","
                                                                            decimalScale={2}
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Min Deposit..."
                                                                            value={gw_item.payment_min_deposit}
                                                                            onValueChange={(values) => {
                                                                                let _gateway_active = gateway_active;
                                                                                _gateway_active[index].payment_min_deposit = values.value;
                                                                                this.setState({
                                                                                    gateway_active: _gateway_active,
                                                                                });
                                                                            }}
                                                                        />
                                                                        <span className="position-absolute text-secondary" style={{ right: 12, top: 6 }}>
                                                                            {gw_item.currency}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                )}
                                            </div>
                                            {/* Withdrawal */}
                                            <div className="col-12 col-lg-6">
                                                <div className="d-flex mb-3">
                                                    <div className="wpx-130 mt-2">Withdraw Gateway</div>
                                                    <Select
                                                        className="form-control"
                                                        placeholder="Withdrawal Gateway..."
                                                        options={this.GatewayOptions(gw_item.currency)}
                                                        onChange={(v) => {
                                                            let _gateway_active = gateway_active;
                                                            _gateway_active[index].gateway_withdrawals = v;
                                                            this.setState({
                                                                gateway_active: _gateway_active,
                                                            });
                                                        }}
                                                        value={gw_item.gateway_withdrawals}
                                                        default={false}
                                                    />
                                                </div>
                                                {/* Withdrawal Detail */}
                                                {gateway_fee_rate?.map(
                                                    (gfr_item, gfr_index) =>
                                                        gfr_item.gateway_name === gw_item.gateway_withdrawals && (
                                                            <div className="row">
                                                                <div className="d-flex align-items-center mb-3">
                                                                    <div className="wpx-130 mt-2">Withdraw Fee Rate{required}</div>
                                                                    <div className="position-relative w-100">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Withdrawal Fee Rate..."
                                                                            onChange={(e) => {
                                                                                if (!float(e.target.value, 4)) return;
                                                                                let _gateway_fee_rate = gateway_fee_rate;
                                                                                _gateway_fee_rate[gfr_index].withdrawal_fee_value = e.target.value;
                                                                                this.MarkEdited(gfr_index, "withdrawal_fee");
                                                                                this.setState({
                                                                                    gateway_fee_rate: _gateway_fee_rate,
                                                                                });
                                                                            }}
                                                                            value={gfr_item.withdrawal_fee_value}
                                                                        />
                                                                        <span className="position-absolute text-secondary" style={{ right: 12, top: 6 }}>
                                                                            {gfr_item.withdrawal_fee_type === "percentage" ? "%" : gw_item.currency}
                                                                        </span>
                                                                    </div>

                                                                    <div
                                                                        className="border-1 border-gray d-flex ms-2"
                                                                        style={{
                                                                            padding: 1,
                                                                            borderRadius: 12,
                                                                            border: "1px #d2d2d2 solid",
                                                                        }}
                                                                    >
                                                                        <button
                                                                            className={`btn ${gfr_item.withdrawal_fee_type === "percentage" ? "btn-dark" : "btn-light"} me-1`}
                                                                            onClick={() => {
                                                                                let _gateway_fee_rate = gateway_fee_rate;
                                                                                _gateway_fee_rate[gfr_index].withdrawal_fee_type = "percentage";
                                                                                this.MarkEdited(gfr_index, "withdrawal_fee");
                                                                                this.setState({
                                                                                    gateway_fee_rate: _gateway_fee_rate,
                                                                                });
                                                                            }}
                                                                        >
                                                                            %
                                                                        </button>
                                                                        <button
                                                                            className={`btn ${gfr_item.withdrawal_fee_type === "fixed" ? "btn-dark" : "btn-light"}`}
                                                                            onClick={() => {
                                                                                let _gateway_fee_rate = gateway_fee_rate;
                                                                                _gateway_fee_rate[gfr_index].withdrawal_fee_type = "fixed";
                                                                                this.MarkEdited(gfr_index, "withdrawal_fee");
                                                                                this.setState({
                                                                                    gateway_fee_rate: _gateway_fee_rate,
                                                                                });
                                                                            }}
                                                                        >
                                                                            {gw_item.currency}
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                {this.ApplyAllButton(gfr_index, "withdrawal_fee", gw_item.currency) && (
                                                                    <div className="d-flex" style={{ marginTop: -12, marginBottom: 12 }}>
                                                                        <div className="wpx-130" />
                                                                        {this.ApplyAllButton(gfr_index, "withdrawal_fee", gw_item.currency)}
                                                                    </div>
                                                                )}
                                                                <div className="d-flex mb-3">
                                                                    <div className="wpx-130 mt-2">Min Withdrawal</div>
                                                                    <div className="position-relative w-100">
                                                                        <NumericFormat
                                                                            thousandSeparator=","
                                                                            decimalScale={2}
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Min Withdrawal..."
                                                                            value={gw_item.payment_min_withdrawal}
                                                                            onValueChange={(values) => {
                                                                                let _gateway_active = gateway_active;
                                                                                _gateway_active[index].payment_min_withdrawal = values.value;
                                                                                this.setState({
                                                                                    gateway_active: _gateway_active,
                                                                                });
                                                                            }}
                                                                        />
                                                                        <span className="position-absolute text-secondary" style={{ right: 12, top: 6 }}>
                                                                            {gw_item.currency}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                )}
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                        {/* Gateway Config */}
                        <div className={`col-12 mb-3 ${active_tab === "gateway" ? "" : "d-none"}`}>
                            <div className="d-flex align-items-center">
                                <div className="pu-modal-heading">Gateway Config</div>
                                {(window.location.href.includes("sandbox") || window.location.href.includes("localhost")) && (
                                    <BtnIcon
                                        className="ms-2 mb-2"
                                        type="approve"
                                        onClick={() => {
                                            this.GetGatewayInfoByID(atob(global.bid));
                                        }}
                                    />
                                )}
                            </div>
                            {/* Gateway picker. The card body selects the gateway, the
                                switch only turns it on or off. */}
                            <div className="d-flex flex-wrap mb-3">
                                {gateway_fee_rate?.map((item, index) => {
                                    // several rows (companies) can share one gateway: one card per gateway
                                    if (gateway_fee_rate.findIndex((e) => e.gateway_name === item.gateway_name) !== index) return null;
                                    const selected = item.gateway_name === filter_gateway;
                                    return (
                                        <div
                                            key={item.gateway_name}
                                            className="d-flex align-items-center justify-content-between pointer me-2 mb-2 px-3 py-2"
                                            style={{
                                                minWidth: 200,
                                                borderRadius: 14,
                                                border: `1px solid ${selected ? "#927530" : "#e6e6e6"}`,
                                                background: selected ? "linear-gradient(270deg, #dabb55, #927530)" : "#ffffff",
                                                color: selected ? "#ffffff" : "#000000",
                                                boxShadow: selected ? "0 4px 12px rgba(146,117,48,0.25)" : "none",
                                                opacity: item.is_active || selected ? 1 : 0.6,
                                            }}
                                            onClick={() => {
                                                this.setState({ filter_gateway: item.gateway_name });
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <GatewayLogo name={item.gateway_name} size={32} on_dark={selected} />
                                                <div className="ms-2">
                                                    <div className="fw-bold text-nowrap">{item.gateway_name}</div>
                                                    <small style={{ opacity: 0.75 }}>{item.is_active ? "Active" : "Inactive"}</small>
                                                </div>
                                            </div>
                                            <div className="ms-3" onClick={(e) => e.stopPropagation()}>
                                                <Switch
                                                    onChange={(e) => {
                                                        gateway_fee_rate.forEach((row) => {
                                                            if (row.gateway_name === item.gateway_name) row.is_active = e;
                                                        });
                                                        this.setState({ gateway_fee_rate });
                                                    }}
                                                    checked={item.is_active}
                                                    height={20}
                                                    width={40}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            {gateway_fee_rate.every((e) => e.gateway_name !== filter_gateway) && (
                                <div className="border rounded-3 p-4 mb-3 text-center text-secondary">
                                    Select a gateway above to configure it.
                                </div>
                            )}
                            {gateway_fee_rate.map((item, index) => {
                                if (item.gateway_name !== filter_gateway) return null;
                                // Which credential fields this gateway uses. Same conditions
                                // as before, named once instead of repeated per input.
                                const show_merchant_id = !["manual", "spark", "scb", "cimb", "chillpay", "xtc", "primerlo"].includes(item.gateway_name);
                                const show_secret_key = !["manual", "uniqpay", "spark", "scb", "cimb", "chillpay", "xtc", "primerlo"].includes(item.gateway_name);
                                const show_apikey = show_secret_key;
                                const show_receiver_id = item.gateway_name === "uniqpay";
                                const show_authen_key = show_merchant_id;
                                const cred_fields = GATEWAY_CREDENTIAL_FIELDS[item.gateway_name];
                                const has_credential = !!cred_fields || show_merchant_id || show_secret_key || show_apikey || show_receiver_id || show_authen_key;
                                const secret_type = show_gateway_secret ? "text" : "password";
                                const entry_count = gateway_fee_rate.filter((e) => e.gateway_name === filter_gateway).length;
                                const usage = item.usage_today;
                                const usage_limit = numberOrNull(item.limit_gmv_per_day);
                                const usage_amount = Number(usage?.total_amount) || 0;
                                const usage_percent = usage_limit ? (usage_amount / usage_limit) * 100 : null;
                                const usage_color = usage_percent === null ? "bg-secondary" : usage_percent >= 90 ? "bg-danger" : usage_percent >= 80 ? "bg-warning" : "bg-success";
                                const company_key = this.CompanyKey(item, index);
                                const is_open = !this.state.collapsed_companies[company_key];
                                // ธนาคารที่ map กับ gateway นี้ใน bank_gateway_mappings ถ้า gateway ยังไม่มี mapping เลย
                                // (เช่น primerlo) ให้เลือกจากธนาคารทั้งหมดแทน ไม่งั้น dropdown ว่าง
                                const mapped_banks = data_bank.filter((e) => e.bank_gateway_mappings?.find((bgm) => bgm.gateway === item.gateway_name));
                                const bank_options = mapped_banks.length ? mapped_banks : data_bank;
                                return (
                                    <div key={company_key} className="mb-1">
                                        <div
                                            className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2 mb-3"
                                            style={{ background: "linear-gradient(270deg, #dabb55, #927530)", color: "#ffffff" }}
                                        >
                                            <div
                                                className="d-flex align-items-center flex-grow-1"
                                                style={{ cursor: "pointer" }}
                                                title={is_open ? "Collapse" : "Expand"}
                                                onClick={() => this.ToggleCompany(company_key)}
                                            >
                                                <GatewayLogo name={item.gateway_name} size={40} on_dark />
                                                <div className="ms-2">
                                                    <div className="fw-bold text-18">{item.gateway_name}</div>
                                                    <small style={{ opacity: 0.85 }}>{item.is_active ? "Active" : "Inactive"}</small>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                {entry_count > 1 && (
                                                    <span className="badge bg-light text-dark me-3">
                                                        {item.company_name || `Company #${item.priority || ""}`}
                                                    </span>
                                                )}
                                                {!item.uid && entry_count > 1 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-light rounded-pill me-3"
                                                        onClick={() => this.RemoveCompany(index)}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                                <div className="me-2">VAT</div>
                                                <Switch
                                                    onChange={(e) => {
                                                        this.SetFormField(index, "is_vat", e);
                                                    }}
                                                    checked={item.is_vat}
                                                />
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm btn-outline-light rounded-circle ms-3 gw-chevron ${is_open ? "open" : ""}`}
                                                    title={is_open ? "Collapse" : "Expand"}
                                                    onClick={() => this.ToggleCompany(company_key)}
                                                >
                                                    <span className="icon">{"\uf078"}</span>
                                                </button>
                                            </div>
                                        </div>

                                        {/* ย่อเหลือแค่หัว (ชื่อ gateway + VAT) ขยายด้วย animation ดู .gw-collapse ใน style.css */}
                                        <div className={`gw-collapse ${is_open ? "open" : ""}`}>
                                        <div>
                                        <div className="pu-section">
                                            <div className="pu-section-title">Company &amp; GMV Limit</div>
                                            <div className="row">
                                                <div className="col-12 col-lg-8">
                                                    {this.FormField({
                                                        label: "Company",
                                                        hint: item.gateway_company_uid
                                                            ? "Daily and monthly limits come from Center Config › Config Company and are shared by every broker"
                                                            : item.company_name
                                                            ? `Not linked: ${item.company_name}${item.business_type ? ` : ${item.business_type}` : ""} uses its own limits. Select a company to share the limit`
                                                            : "Select a company set up in Center Config › Config Company",
                                                        value: item.gateway_company_uid ?? "",
                                                        children: (
                                                            <Select
                                                                className="form-control pr-input"
                                                                placeholder="Company : Business Type..."
                                                                options={this.state.data_gateway_company
                                                                    .filter((c) => c.gateway_name === item.gateway_name)
                                                                    .map((c) => ({ value: c.uid, label: `${c.company_name} : ${c.business_type}` }))}
                                                                onChange={(v) => this.SelectGatewayCompany(index, v)}
                                                                value={item.gateway_company_uid ?? ""}
                                                            ></Select>
                                                        ),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-4">
                                                    {this.FormField({
                                                        label: "Priority",
                                                        type: "number",
                                                        hint: "Lower number is chosen first",
                                                        value: item.priority ?? "",
                                                        onChange: (e) => this.SetFormField(index, "priority", e.target.value),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-3">
                                                    {this.FormField({
                                                        label: "Min GMV / Transaction (THB)",
                                                        value: item.min_gmv_per_transaction ?? "",
                                                        children: (
                                                            <NumericFormat
                                                                thousandSeparator=","
                                                                decimalScale={2}
                                                                allowNegative={false}
                                                                type="text"
                                                                className="form-control pr-input"
                                                                placeholder="No minimum"
                                                                value={item.min_gmv_per_transaction ?? ""}
                                                                onValueChange={(values) => this.SetFormField(index, "min_gmv_per_transaction", values.value)}
                                                            />
                                                        ),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-3">
                                                    {this.FormField({
                                                        label: "Limit GMV / Transaction (THB)",
                                                        value: item.limit_gmv_per_transaction ?? "",
                                                        children: (
                                                            <NumericFormat
                                                                thousandSeparator=","
                                                                decimalScale={2}
                                                                allowNegative={false}
                                                                type="text"
                                                                className="form-control pr-input"
                                                                placeholder="Unlimited"
                                                                value={item.limit_gmv_per_transaction ?? ""}
                                                                onValueChange={(values) => this.SetFormField(index, "limit_gmv_per_transaction", values.value)}
                                                            />
                                                        ),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-3">
                                                    {this.FormField({
                                                        label: "Limit GMV / Day (THB)",
                                                        value: item.limit_gmv_per_day ?? "",
                                                        children: (
                                                            <NumericFormat
                                                                thousandSeparator=","
                                                                decimalScale={2}
                                                                allowNegative={false}
                                                                type="text"
                                                                className="form-control pr-input"
                                                                placeholder="Unlimited"
                                                                value={item.limit_gmv_per_day ?? ""}
                                                                disabled
                                                                title="Set in Center Config › Config Company"
                                                            />
                                                        ),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-3">
                                                    {this.FormField({
                                                        label: "Limit GMV / Month (THB)",
                                                        value: item.limit_gmv_per_month ?? "",
                                                        children: (
                                                            <NumericFormat
                                                                thousandSeparator=","
                                                                decimalScale={2}
                                                                allowNegative={false}
                                                                type="text"
                                                                className="form-control pr-input"
                                                                placeholder="Unlimited"
                                                                value={item.limit_gmv_per_month ?? ""}
                                                                disabled
                                                                title="Set in Center Config › Config Company"
                                                            />
                                                        ),
                                                    })}
                                                </div>
                                            </div>
                                            {usage && (
                                                <div>
                                                    <small>
                                                        Used today{item.usage_scope === "company" ? " (all brokers)" : ""}: {usage_amount.toLocaleString(undefined, { maximumFractionDigits: 2 })} /{" "}
                                                        {usage_limit === null ? "Unlimited" : usage_limit.toLocaleString()}
                                                        {usage_percent !== null && ` (${usage_percent.toFixed(1)}%)`}
                                                    </small>
                                                    {usage_percent !== null && (
                                                        <div className="progress mt-1" style={{ height: 6 }}>
                                                            <div
                                                                className={`progress-bar ${usage_color}`}
                                                                role="progressbar"
                                                                style={{ width: `${Math.min(100, usage_percent)}%` }}
                                                                aria-valuenow={Math.min(100, usage_percent)}
                                                                aria-valuemin={0}
                                                                aria-valuemax={100}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <div className="pu-section">
                                            <div className="pu-section-title">Callback &amp; Return URL</div>
                                            <div className="row">
                                                <div className="col-12 col-lg-6">
                                                    {this.FormField({
                                                        label: "Callback Deposit",
                                                        placeholder: "https://...",
                                                        copy: true,
                                                        value: item.callback_url,
                                                        onChange: (e) => this.SetApplyField(index, "callback_url", e.target.value, "callback_url"),
                                                        action: this.ApplyAllButton(index, "callback_url"),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    {this.FormField({
                                                        label: "Callback Withdraw",
                                                        placeholder: "https://...",
                                                        copy: true,
                                                        value: item.callback_url_withdrawal,
                                                        onChange: (e) => this.SetApplyField(index, "callback_url_withdrawal", e.target.value, "callback_url_withdrawal"),
                                                        action: this.ApplyAllButton(index, "callback_url_withdrawal"),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    {this.FormField({
                                                        label: "Return Deposit",
                                                        placeholder: "https://...",
                                                        copy: true,
                                                        value: item.return_url,
                                                        onChange: (e) => this.SetApplyField(index, "return_url", e.target.value, "return_url"),
                                                        action: this.ApplyAllButton(index, "return_url"),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    {this.FormField({
                                                        label: "Return Withdraw",
                                                        placeholder: "https://...",
                                                        copy: true,
                                                        value: item.return_url_withdrawal,
                                                        onChange: (e) => this.SetApplyField(index, "return_url_withdrawal", e.target.value, "return_url_withdrawal"),
                                                        action: this.ApplyAllButton(index, "return_url_withdrawal"),
                                                    })}
                                                </div>
                                            </div>
                                        </div>

                                        {has_credential && (
                                            <div className="pu-section">
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <b>Credentials</b>
                                                    <small
                                                        className="pointer"
                                                        style={{ color: "#927530" }}
                                                        onClick={() => {
                                                            this.setState({ show_gateway_secret: !show_gateway_secret });
                                                        }}
                                                    >
                                                        {show_gateway_secret ? "Hide" : "Show"}
                                                    </small>
                                                </div>
                                                <div className="row">
                                                    {cred_fields?.map((f) => {
                                                        const is_plain = f.key === "merchant_code" || f.key === "client_id" || f.key === "merchant_id";
                                                        const reveal_key = `${company_key}:${f.key}`;
                                                        const shown = show_gateway_secret || !!this.state.reveal_fields[reveal_key];
                                                        return (
                                                            <div className="col-12 col-lg-6" key={f.key}>
                                                                {this.FormField({
                                                                    label: f.label,
                                                                    placeholder: `${f.label}...`,
                                                                    type: is_plain || shown ? "text" : "password",
                                                                    copy: true,
                                                                    reveal: is_plain ? undefined : { shown, onToggle: () => this.ToggleReveal(reveal_key) },
                                                                    value: item.credentials?.[f.key] ?? "",
                                                                    onChange: (e) => this.SetCredential(index, f.key, e.target.value),
                                                                })}
                                                            </div>
                                                        );
                                                    })}
                                                    {show_merchant_id && (
                                                        <div className="col-12 col-lg-6">
                                                            {this.FormField({
                                                                label: "Merchant ID",
                                                                placeholder: "Merchant ID...",
                                                                copy: true,
                                                                value: item.merchant_id,
                                                                onChange: (e) => this.SetFormField(index, "merchant_id", e.target.value),
                                                            })}
                                                        </div>
                                                    )}
                                                    {show_secret_key && (
                                                        <div className="col-12 col-lg-6">
                                                            {this.FormField({
                                                                label: "Merchant Secret Key",
                                                                placeholder: "Merchant Secret Key...",
                                                                type: secret_type,
                                                                copy: true,
                                                                value: item.merchant_secret_key,
                                                                onChange: (e) => this.SetFormField(index, "merchant_secret_key", e.target.value),
                                                            })}
                                                        </div>
                                                    )}
                                                    {show_apikey && (
                                                        <div className="col-12 col-lg-6">
                                                            {this.FormField({
                                                                label: "API Key",
                                                                placeholder: "API Key...",
                                                                type: secret_type,
                                                                copy: true,
                                                                value: item.apikey,
                                                                onChange: (e) => this.SetFormField(index, "apikey", e.target.value),
                                                            })}
                                                        </div>
                                                    )}
                                                    {show_receiver_id && (
                                                        <div className="col-12 col-lg-6">
                                                            {this.FormField({
                                                                label: "Receiver ID",
                                                                value: item.apikey,
                                                                children: (
                                                                    <Select
                                                                        className="form-control"
                                                                        placeholder="Receiver ID..."
                                                                        options={[
                                                                            { value: "", label: "--Receiver ID--" },
                                                                            ...global.bank_laos.map((e) => ({
                                                                                value: e.receiver_id,
                                                                                label: `${e.bank_account_number} | ${e.bank_account_name}`,
                                                                            })),
                                                                        ]}
                                                                        onChange={(v) => {
                                                                            let _gateway_fee_rate = gateway_fee_rate;
                                                                            _gateway_fee_rate[index].apikey = v;
                                                                            let bank = global.bank_laos?.find((b) => b.receiver_id === v);
                                                                            _gateway_fee_rate[index].bank_code = bank?.bank_code || "";
                                                                            _gateway_fee_rate[index].bank_account_number = bank?.bank_account_number || "";
                                                                            _gateway_fee_rate[index].bank_account_name_th = bank?.bank_account_name || "";
                                                                            _gateway_fee_rate[index].bank_account_name_en = bank?.bank_account_name || "";
                                                                            this.setState({
                                                                                gateway_fee_rate: _gateway_fee_rate,
                                                                            });
                                                                        }}
                                                                        value={item.apikey}
                                                                        default={false}
                                                                    />
                                                                ),
                                                            })}
                                                        </div>
                                                    )}
                                                    {show_authen_key && (
                                                        <div className="col-12">
                                                            {this.FormField({
                                                                label: "Authen Key",
                                                                value: item.authen_key,
                                                                copy: true,
                                                                children: show_gateway_secret ? (
                                                                    <textarea
                                                                        rows={7}
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Authen Key..."
                                                                        onChange={(e) => {
                                                                            this.SetFormField(index, "authen_key", e.target.value);
                                                                        }}
                                                                        value={item.authen_key}
                                                                    />
                                                                ) : (
                                                                    // Collapsed by default: the key is long and rarely edited,
                                                                    // so the panel stays readable until Show is clicked.
                                                                    <div className="form-control bg-light text-secondary d-flex align-items-center" style={{ height: 42 }}>
                                                                        {item.authen_key
                                                                            ? `Hidden (${item.authen_key.length} characters) - click Show to edit`
                                                                            : "Empty - click Show to edit"}
                                                                    </div>
                                                                ),
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        <div className="pu-section">
                                            <div className="pu-section-title">Bank Account</div>
                                            <div className="row">
                                                <div className="col-12 col-lg-6">
                                                    {this.FormField({
                                                        label: "Bank Name",
                                                        value: item.bank_code,
                                                        children: (
                                                            <Select
                                                                className="form-control"
                                                                placeholder="Account Name..."
                                                                options={bank_options}
                                                                onChange={(e) => {
                                                                    this.SetFormField(index, "bank_code", e);
                                                                }}
                                                                value={item.bank_code}
                                                            ></Select>
                                                        ),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    {this.FormField({
                                                        label: "Account Number",
                                                        placeholder: "Account Number...",
                                                        maxLength: 20,
                                                        copy: true,
                                                        value: item.bank_account_number,
                                                        onChange: (e) => {
                                                            if (!float(e.target.value)) return;
                                                            this.SetFormField(index, "bank_account_number", e.target.value);
                                                        },
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    {this.FormField({
                                                        label: "Account Name TH",
                                                        placeholder: "Account NameTH...",
                                                        value: item.bank_account_name_th,
                                                        onChange: (e) => this.SetFormField(index, "bank_account_name_th", e.target.value),
                                                    })}
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    {this.FormField({
                                                        label: "Account Name EN",
                                                        placeholder: "Account NameEN...",
                                                        value: item.bank_account_name_en,
                                                        onChange: (e) => this.SetFormField(index, "bank_account_name_en", e.target.value),
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                );
                            })}
                            {gateway_fee_rate.some((e) => e.gateway_name === filter_gateway) && (
                                <div className="mb-3">
                                    <button type="button" className="btn btn-outline-dark rounded-pill px-4" onClick={this.AddCompany}>
                                        + Add company
                                    </button>
                                </div>
                            )}
                            <div className="pu-section">
                                <div className="d-flex align-items-center mb-1">
                                    <b className="d-block">Queue</b>
                                    <span className="badge bg-secondary ms-2">Coming soon</span>
                                </div>
                                <small className="text-secondary d-block">Applies to the whole broker, not to a single gateway.</small>
                                <small className="text-secondary d-block mb-3">This feature is under development and not available yet.</small>
                                <div className="row text-secondary" style={{ opacity: 0.55, pointerEvents: "none" }}>
                                    <div className="col-12 col-md-6 d-flex align-items-center mb-2">
                                        <Switch
                                            disabled={true}
                                            onChange={(e) => {
                                                this.setState({
                                                    is_deposit_queue: e,
                                                });
                                            }}
                                            checked={is_deposit_queue}
                                        />
                                        <div className="ms-2">Deposit Queue</div>
                                    </div>
                                    <div className="col-12 col-md-6 d-flex align-items-center mb-2">
                                        <Switch
                                            disabled={true}
                                            onChange={(e) => {
                                                this.setState({
                                                    is_withdrawal_queue: e,
                                                });
                                            }}
                                            checked={is_withdrawal_queue}
                                        />
                                        <div className="ms-2">Withdrawal Queue</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="pr-modal-footer">
                    <div className="d-flex">
                        <button
                            className="btn btn-dark px-5 me-1 rounded-pill"
                            onClick={() => {
                                this.CreateUpdate();
                            }}
                        >
                            Submit
                        </button>
                        <button
                            className="btn btn-outline-dark px-5 ms-1 rounded-pill"
                            onClick={() => {
                                this.setState({ modal_create: false, modal_update: false });
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={modal_update_wallet} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_update_wallet: false })}>
                <Modal.Header className="pr-modal-header" closeButton>
                    <div>
                        <div className="pr-modal-eyebrow">Wallet</div>
                        <h5 className="fw-bold mb-0">Update Setting Wallet Broker</h5>
                    </div>
                </Modal.Header>
                <Modal.Body className="pr-modal-body">
                    {/* GATEWAY */}
                    {wallets.map((item, index) => (
                        <div className="mb-3">
                            <label className="pr-label">Min Balance ({item.currency})</label>
                            <NumericFormat
                                thousandSeparator=","
                                decimalScale={2}
                                type="text"
                                className="form-control pr-input"
                                value={item.min_balance}
                                onValueChange={(values) => {
                                    wallets[index].min_balance = values.value;
                                    this.setState({ wallets });
                                }}
                            />
                        </div>
                    ))}
                </Modal.Body>
                <Modal.Footer className="pr-modal-footer">
                    <div className="d-flex">
                        <button
                            className="btn btn-dark px-5 me-1 rounded-pill"
                            onClick={() => {
                                this.CreateUpdate();
                            }}
                        >
                            Submit
                        </button>
                        <button
                            className="btn btn-outline-dark px-5 ms-1 rounded-pill"
                            onClick={() => {
                                this.setState({ modal_update_wallet: false });
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={modal_send_certificate} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_send_certificate: false })}>
                <Modal.Header className="pr-modal-header" closeButton>
                    <div>
                        <div className="pr-modal-eyebrow">Certificate</div>
                        <h5 className="fw-bold mb-0">Send Certification to email</h5>
                    </div>
                </Modal.Header>
                <Modal.Body className="pr-modal-body">
                    <div className="mb-3">
                        <label className="pr-label">Email</label>
                        <div className="pu-hint mb-2">One or more recipients. The certificate is sent as an attachment.</div>
                        <textarea
                            type="text"
                            className="form-control pr-input"
                            onChange={(e) => {
                                this.setState({ email: e.target.value });
                            }}
                            value={email}
                            rows={5}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="pr-modal-footer">
                    <div className="d-flex">
                        <button
                            className="btn btn-dark px-5 me-1 rounded-pill"
                            onClick={() => {
                                this.ExportCertificate();
                            }}
                        >
                            Submit
                        </button>
                        <button
                            className="btn btn-outline-dark px-5 ms-1 rounded-pill"
                            onClick={() => {
                                this.setState({ modal_send_certificate: false });
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={modal_payment}
                dialogClassName="pr-modal pr-scope pu-scope"
                onHide={() => {
                    this.ClosePrimerloKyc();
                    this.setState({ modal_payment: false });
                }}
            >
                <Modal.Header className="pr-modal-header" closeButton>
                    <div>
                        <div className="pr-modal-eyebrow">Manual transaction</div>
                        <h5 className="fw-bold mb-0">{primerlo_kyc ? "Verify customer" : "Create Deposit Withdraw"}</h5>
                    </div>
                </Modal.Header>
                {primerlo_kyc ? (
                    <Modal.Body className="pr-modal-body">
                        {primerlo_kyc.message ? <div className="alert alert-warning py-2">{primerlo_kyc.message}</div> : null}
                        <div id="primerlo-kyc-widget" className="w-100" style={{ minHeight: 420 }} />
                    </Modal.Body>
                ) : (
                <Modal.Body className="pr-modal-body">
                    <div className="mb-3">
                        <label className="pr-label">Currency</label>
                        <Select
                            className="form-control"
                            placeholder="Currency..."
                            options={global.currency?.map((e) => ({
                                label: e.currency_name,
                                value: e.currency_code,
                                front: e.image,
                            }))}
                            onChange={async (e, i) => {
                                this.setState(
                                    {
                                        currency: e,
                                        customer_id: "",
                                        filter_currency: e,
                                    },
                                    () => {
                                        this.GetCustomer();
                                    }
                                );
                            }}
                            value={currency}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="pr-label">Customer{required}</label>
                        <Select
                            className="form-control"
                            placeholder="Customer..."
                            options={data_customer}
                            onChange={(e) => {
                                this.setState({ customer_id: e });
                            }}
                            onKeyUp={(e) => {
                                this.GetCustomer(e);
                            }}
                            value={customer_id}
                            disabled={!currency}
                        ></Select>
                    </div>
                    <div className="mb-3">
                        <label className="pr-label">Payment Type{required}</label>
                        <Select
                            className="form-control"
                            placeholder="Payment Type..."
                            options={[
                                { value: "deposits", label: "Deposit" },
                                { value: "withdrawals", label: "Withdrawal" },
                            ]}
                            onChange={(v) => {
                                this.setState({ payment_type: v });
                            }}
                            value={payment_type}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="pr-label">Amount{required}</label>
                        <div className="position-relative">
                            <NumericFormat
                                thousandSeparator=","
                                decimalScale={2}
                                type="text"
                                className="form-control pr-input pe-5"
                                placeholder="0.00"
                                value={amount}
                                onValueChange={(values) => this.setState({ amount: values.value })}
                            />
                            <span className="pu-input-suffix">{currency || "THB"}</span>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="pr-label">Ref No{required}</label>
                        <div className="pu-password">
                            <input
                                type="text"
                                className="form-control pr-input"
                                placeholder="Ref No..."
                                onChange={(e) => {
                                    this.setState({ ref_no: e.target.value });
                                }}
                                value={ref_no}
                            />
                            <button
                                type="button"
                                className="pu-generate"
                                onClick={(e) => {
                                    this.setState({ ref_no: new Date().getTime().toString() });
                                }}
                            >
                                <span className="icon me-2">{"\uf074"}</span>Generate
                            </button>
                        </div>
                    </div>
                </Modal.Body>
                )}
                <Modal.Footer className="pr-modal-footer">
                    {primerlo_kyc ? (
                        <>
                            {primerlo_kyc.message ? (
                                <button
                                    className="btn btn-dark px-5 me-1 rounded-pill"
                                    onClick={() => {
                                        // เปิด widget ใหม่ = ขอ session kyc ใหม่ (ลิงก์เดิมใช้ซ้ำไม่ได้)
                                        this.setState({ primerlo_kyc: null }, () => this.CreatePayment());
                                    }}
                                >
                                    Retry
                                </button>
                            ) : null}
                            <button className="btn btn-outline-dark px-5 ms-1 rounded-pill" onClick={this.ClosePrimerloKyc}>
                                Back
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                className="btn btn-dark px-5 me-1 rounded-pill"
                                onClick={() => {
                                    this.CreatePayment();
                                }}
                            >
                                Submit
                            </button>
                            <button
                                className="btn btn-outline-dark px-5 ms-1 rounded-pill"
                                onClick={() => {
                                    this.setState({ modal_payment: false });
                                }}
                            >
                                Cancel
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
